// =============================================================================
// Lazy Alpine Initialization for below-fold sections
// =============================================================================
(function setupAlpineLazyInit() {
  if (typeof Shopify !== 'undefined' && Shopify.designMode) return;
  let viewportH = window.innerHeight;
  let lazyToMark = [];
  document.querySelectorAll('.shopify-section').forEach(function(section) {
  // Ne jamais différer la grille principale des collections
  if (section.querySelector('#ProductGridContainer, #ItemsGrid')) return;

  if (!section.querySelector('[x-data],[x-show],[x-bind],[x-on],[x-intersect],[x-transition],[data-fade-on-intersect],[x-cloak]')) return;

  let rect = section.getBoundingClientRect();
  if (rect.top >= viewportH) lazyToMark.push(section);
});
  lazyToMark.forEach(function(section) {
    section.setAttribute('x-ignore', '');
    section.setAttribute('data-alpine-lazy', '');
  });
  document.addEventListener('alpine:initialized', function() {
    let lazyEls = document.querySelectorAll('[data-alpine-lazy]');
    if (!lazyEls.length) return;
    let sectionObserver = new IntersectionObserver(function(entries, obs) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;
        let el = entry.target;
        obs.unobserve(el);
        el.removeAttribute('x-ignore');
        delete el._x_ignore;
        if (!el.hasAttribute('x-data')) el.setAttribute('x-data', '{}');
        Alpine.initTree(el);
        if (window._fadeObserver) window._fadeObserver.observe(el);
      });
    }, { rootMargin: '300px 0px' });
    lazyEls.forEach(function(el) { sectionObserver.observe(el); });
  });
})();

const installMediaQueryWatcher = (mediaQuery, changedCallback) => {
  const mq = window.matchMedia(mediaQuery);
  mq.addEventListener("change", (e) => changedCallback(e.matches));
  changedCallback(mq.matches);
};

const deferScriptLoad = (name, src, onload, requestVisualChange = false) => {
  ((events) => {
    const loadScript = () => {
      events.forEach((type) => window.removeEventListener(type, loadScript));
      clearTimeout(autoloadScript);
      const initScript = () => {
        const script = document.createElement("script");
        script.setAttribute("src", src);
        script.setAttribute("defer", "");
        script.onload = () => {
          window.Maximize.loadedScript.push(name);
          document.dispatchEvent(new CustomEvent(name + " loaded"));
          onload();
        };
        document.head.appendChild(script);
      };
      if (requestVisualChange) {
        if (window.requestIdleCallback) { requestIdleCallback(initScript); }
        else { requestAnimationFrame(initScript); }
      } else { initScript(); }
    };
    let autoloadScript;
    if (Shopify.designMode) {
      loadScript();
    } else {
      const wait = window.innerWidth >= MIN_DEVICE_WIDTH.tablet ? 2000 : 5000;
      events.forEach((type) => window.addEventListener(type, loadScript, {once: true, passive: true}));
      autoloadScript = setTimeout(() => { loadScript(); }, wait);
    }
  })(["touchstart", "mouseover", "wheel", "scroll", "keydown"]);
};

const getSectionInnerHTML = (html, selector = ".shopify-section") => {
  return new DOMParser().parseFromString(html, "text/html").querySelector(selector)?.innerHTML;
};

const xParseJSON = (jsonString) => {
  jsonString = String.raw`${jsonString}`;
  jsonString = jsonString.replaceAll("\\", "\\\\").replaceAll('\\"', '"');
  return JSON.parse(jsonString);
};

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xDarkMode", {
      isToggling: false,
      toggleThemeMode() {
        if (this.isToggling) return;
        this.isToggling = true;
        requestAnimationFrame(() => {
          document.documentElement.classList.add("show-icon-toggle-loading");
          requestAnimationFrame(() => {
            document.documentElement.classList.add("disable-transition-effect");
            const isDark = document.documentElement.classList.contains("dark");
            localStorage.maximize_theme = isDark ? 0 : 1;
            document.documentElement.classList.toggle("dark", !isDark);
            document.documentElement.classList.remove("show-icon-toggle-loading");
            requestAnimationFrame(() => {
              document.documentElement.classList.remove("disable-transition-effect");
              this.isToggling = false;
            });
          });
        });
      },
    });

    Alpine.store("xHelper", {
      countdown(configs, callback) {
        let endDate = new Date(configs.end_year, configs.end_month - 1, configs.end_day, configs.end_hour, configs.end_minute);
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(configs.start_year, configs.start_month - 1, configs.start_day, configs.start_hour, configs.start_minute);
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else { startTime = new Date().getTime(); }
        let x = setInterval(function () {
          let now = new Date().getTime();
          let distance = endTime - now;
          if (distance < 0 || startTime > now) {
            callback(false, 0, 0, 0, 0); clearInterval(x);
          } else {
            let days = Math.floor(distance / (1000 * 60 * 60 * 24));
            let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
            let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((distance % (1000 * 60)) / 1000);
            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            callback(true, seconds, minutes, hours, days);
          }
        }, 1000);
      },
      countdownByTime(startTime = Date.now(), endTime, callback) {
        const x = setInterval(() => {
          const now = Date.now();
          const distance = endTime - now;
          if (distance < 0 || startTime > now) { callback(false, 0, 0, 0, 0); clearInterval(x); return; }
          const days = Math.floor(distance / MS_PER_DAY);
          const hours = Math.floor((distance % MS_PER_DAY) / MS_PER_HOUR);
          let minutes = Math.floor((distance % MS_PER_HOUR) / MS_PER_MINUTE);
          let seconds = Math.floor((distance % MS_PER_MINUTE) / MS_PER_SECOND);
          minutes = minutes < 10 ? "0" + minutes : minutes;
          seconds = seconds < 10 ? "0" + seconds : seconds;
          callback(true, seconds, minutes, hours, days);
        }, 1000);
      },
      canShow(configs) {
        let endDate = new Date(configs.end_year, configs.end_month - 1, configs.end_day, configs.end_hour, configs.end_minute);
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(configs.start_year, configs.start_month - 1, configs.start_day, configs.start_hour, configs.start_minute);
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else { startTime = new Date().getTime(); }
        let now = new Date().getTime();
        let distance = endTime - now;
        if (distance < 0 || startTime > now) { return false; }
        return true;
      },
      handleTime(configs) {
        let endDate = new Date(configs.end_year, configs.end_month - 1, configs.end_day, configs.end_hour, configs.end_minute);
        const endTime = endDate.getTime() + (-1 * configs.timezone * 60 - endDate.getTimezoneOffset()) * 60 * 1000;
        let startTime;
        if (configs.start_year) {
          let startDate = new Date(configs.start_year, configs.start_month - 1, configs.start_day, configs.start_hour, configs.start_minute);
          startTime = startDate.getTime() + (-1 * configs.timezone * 60 - startDate.getTimezoneOffset()) * 60 * 1000;
        } else { startTime = new Date().getTime(); }
        let now = new Date().getTime();
        let distance = endTime - now;
        return {"startTime": startTime, "endTime": endTime, "now": now, "distance": distance};
      },
      setPosition(destinationId, elementId) {
        let destinationElem = document.querySelector(destinationId);
        let movedElem = document.querySelector(elementId);
        if (destinationElem && movedElem) {
          destinationElem.innerHTML = movedElem.innerHTML;
          Alpine.initTree(destinationElem);
          if (window._fadeObserver) {
            destinationElem.querySelectorAll('[data-fade-on-intersect]').forEach(function(el) { el.removeAttribute('data-fade-observed'); });
            window._fadeObserver.observe(destinationElem);
          }
          const resizeEvent = new CustomEvent('resize');
          window.dispatchEvent(resizeEvent);
        }
      },
      dragToScroll(el, checkCanDrag = false) {
        const container = el;
        let isDragging = false, startX, scrollLeft, canDrag = true;
        if (container) {
          container.addEventListener('mousedown', (e) => { isDragging = true; startX = e.pageX - container.offsetLeft; scrollLeft = container.scrollLeft; });
          container.addEventListener('mousemove', (e) => {
            if (!isDragging || !canDrag) return;
            e.preventDefault();
            const x = e.pageX - container.offsetLeft;
            const walk = x - startX;
            container.scrollLeft = scrollLeft - walk;
            requestAnimationFrame(() => { if (Math.abs(walk) > THRESHOLD.startScroll) { container.dataset.dragStartedScroll = "true"; } });
          });
          container.addEventListener('mouseup', () => { if (!canDrag) return; isDragging = false; requestAnimationFrame(() => { container.removeAttribute("data-drag-started-scroll"); }); });
          container.addEventListener('mouseleave', () => { if (isDragging) { isDragging = false; } });
          if (checkCanDrag) {
            const updateCursorContainer = () => {
              if (container.scrollWidth > container.clientWidth) { container.classList.add('cursor-grab', 'select-none'); canDrag = true; }
              else { container.classList.remove('cursor-grab', 'select-none'); canDrag = false; }
            };
            updateCursorContainer();
            window.addEventListener('resize', debounce(() => { updateCursorContainer(); }, TIMEOUT.resize));
          }
        }
      }
    });

    Alpine.data("xScrollNav", () => ({
      isRtl: window.Maximize.rtl,
      linkList: "", show: false, isAtStart: true, isAtEnd: false,
      navContentEl: null, navContentWidth: 0, navButtonWidth: 0,
      __debounce(func, wait) {
        let timeout;
        return function (...args) { clearTimeout(timeout); timeout = setTimeout(() => func.apply(this, args), wait); };
      },
      init() {
        this.linkList = this.$el.querySelector(".link-list");
        this.linkList.addEventListener("scroll", () => { this.__debounce(this.checkScroll(), 20); });
        this.navContentEl = this.linkList.closest(".nav-content");
        this.navContentWidth = this.navContentEl.offsetWidth;
        const navButtons = this.$el.getElementsByClassName('scroll-nav');
        Alpine.nextTick(() => {
          const updateNavButtonWidth = () => {
            this.navButtonWidth = 0;
            Array.from(navButtons).forEach((button) => { if (this.navButtonWidth == 0) { this.navButtonWidth = button.getBoundingClientRect().width; } });
          };
          installMediaQueryWatcher(`(min-width: ${MIN_DEVICE_WIDTH.tablet}px)`, updateNavButtonWidth);
        });
        this.checkNavIsOverflow();
        let _self = this;
        let _visObs = new IntersectionObserver(function(entries) {
          entries.forEach(function(entry) { if (entry.isIntersecting) { _self.checkNavIsOverflow(); _visObs.unobserve(entry.target); } });
        });
        _visObs.observe(this.$el);
        window.addEventListener("resize", () => { this.__debounce(this.checkNavIsOverflow(), 300); this.__debounce(this.checkScroll(), 20); });
      },
      checkNavIsOverflow() { this.navContentWidth = this.navContentEl.offsetWidth; this.show = this.linkList.scrollWidth > this.navContentWidth; },
      scrollToLeft() {
        const multiplier = (window.innerWidth < MIN_DEVICE_WIDTH.tablet) ? 0.5 : 0.3;
        this.linkList.scroll({ top: 0, left: this.linkList.scrollLeft - (this.isRtl ? -(this.navContentWidth * multiplier) : (this.navContentWidth * multiplier)), behavior: "smooth" });
        this.checkScroll();
      },
      scrollToRight() {
        const multiplier = (window.innerWidth < MIN_DEVICE_WIDTH.tablet) ? 0.5 : 0.3;
        this.linkList.scroll({ top: 0, left: this.linkList.scrollLeft + (this.isRtl ? -(this.navContentWidth * multiplier) : (this.navContentWidth * multiplier)), behavior: "smooth" });
        this.checkScroll();
      },
      checkScroll() {
        setTimeout(() => {
          const {scrollWidth, offsetWidth, scrollLeft} = this.linkList;
          this.isScrollable = scrollWidth > offsetWidth;
          const endOffset = scrollWidth - offsetWidth;
          if (this.isRtl) { this.isAtStart = Math.abs(scrollLeft) <= 1; this.isAtEnd = Math.abs(scrollLeft) >= endOffset - 2; }
          else { this.isAtStart = scrollLeft <= 1; this.isAtEnd = scrollLeft + offsetWidth >= scrollWidth - 2; }
        }, 300);
      },
      scrollToActiveItem(activeItem, hasEdgeGap) {
        const activeChild = activeItem || this.linkList.querySelector('.block-text-button__wrapper.is-active');
        if (!activeChild) return;
        const childRect = activeChild.getBoundingClientRect();
        const linkListRect = this.linkList.getBoundingClientRect();
        let offsetLeft = this.linkList.scrollLeft;
        if (this.isRtl) { offsetLeft += (childRect.right - linkListRect.right); }
        else { offsetLeft += (childRect.left - linkListRect.left); }
        if (hasEdgeGap && this.navButtonWidth) { offsetLeft += (this.navButtonWidth * 2) * (this.isRtl ? 1 : -1); }
        this.linkList.scroll({ left: offsetLeft, behavior: 'smooth' });
        this.checkScroll();
      }
    }));

    Alpine.store("xMaximizePopup", {
      isOpen: false,
      handleOpen: function (activeElement) {
        this.isOpen = true;
        if (window.Maximize.isShowPopupOverlay) document.body.classList.add("overflow-y-hidden");
        if (activeElement) { setTimeout(() => { document.querySelector(`${activeElement}`)?.focus(); }, 500); }
      },
      handleClose: function () {
        Alpine.store('xFocusElement').removeTrapFocus();
        setTimeout(() => { this.isOpen = false; if (window.Maximize.isShowPopupOverlay) document.body.classList.remove("overflow-y-hidden"); }, 500);
      }
    });

    Alpine.store("xMaximizeDrawer", {
      isOpen: false, activeDrawerElement: false, durationTime: 0, drawerCloseElement: false,
      handleOpen: function (drawerContainer) {
        const drawerContainerEle = document.querySelector(drawerContainer);
        if (drawerContainerEle) {
          this.activeDrawerElement = drawerContainerEle;
          this.durationTime = DURATION.DRAWER_TRANSITION;
          drawerContainerEle.classList.add("is-open");
          this.isOpen = true;
          document.body.classList.add("overflow-y-hidden");
        }
        if (!this.drawerCloseElement) { this.drawerCloseElement = this.activeDrawerElement; }
      },
      handleClose: function (isCloseAllDrawer = true) {
        Alpine.store('xFocusElement').removeTrapFocus();
        this.isOpen = false;
        if (this.activeDrawerElement) { this.activeDrawerElement.classList.remove("is-open"); }
        if (isCloseAllDrawer) {
          setTimeout(() => {
            if (this.activeDrawerElement === this.drawerCloseElement || !this.activeDrawerElement) {
              document.body.classList.remove("overflow-y-hidden");
              this.drawerCloseElement = false;
            } else { this.drawerCloseElement = this.activeDrawerElement; }
            this.activeDrawerElement = false;
          }, this.durationTime);
        } else { this.activeDrawerElement = this.drawerCloseElement; }
      }
    });

    Alpine.store("xFocusElement", {
      focusableElements: ['button, [href], input:not([hidden]), select, textarea, [tabindex]:not([tabindex^="-"]), a:not([aria-disabled="true"])'],
      listeners: {}, activeElement: null,
      isFocusable(el) {
        if (!el) return false;
        const style = getComputedStyle(el);
        if (!el.offsetParent || style.visibility === 'hidden' || style.display === 'none') { return false; }
        const tabindex = el.getAttribute('tabindex');
        if (tabindex !== null && parseInt(tabindex, 10) === -1) { return false; }
        return true;
      },
      trapFocus(containerSelector, elementFocusSelector) {
        const container = document.getElementById(containerSelector);
        const elementFocus = document.getElementById(elementFocusSelector);
        if (document.activeElement !== document.body && !container.contains(document.activeElement)) { this.activeElement = document.activeElement; }
        this.listeners = this.listeners || {};
        if (container) {
          const elements = Array.from(container.querySelectorAll(this.focusableElements));
          let firstEl = null, lastEl = null;
          for (let i = 0; i <= elements.length - 1; i++) { if (this.isFocusable(elements[i])) { firstEl = elements[i]; break; } }
          for (let i = elements.length - 1; i >= 0; i--) { if (this.isFocusable(elements[i])) { lastEl = elements[i]; break; } }
          this.removeTrapFocus();
          this.listeners.focusin = (event) => { if (event.target !== container && event.target !== lastEl && event.target !== firstEl) { return; } document.addEventListener("keydown", this.listeners.keydown); };
          this.listeners.focusout = () => { document.removeEventListener("keydown", this.listeners.keydown); };
          this.listeners.keydown = (e) => {
            if (e.code.toUpperCase() !== "TAB") return;
            if (e.target === lastEl && !e.shiftKey) { e.preventDefault(); firstEl.focus(); }
            if ((e.target === firstEl || e.target == container) && e.shiftKey) { e.preventDefault(); lastEl.focus(); }
          };
          document.addEventListener("focusout", this.listeners.focusout);
          document.addEventListener("focusin", this.listeners.focusin);
          elementFocus?.focus();
        }
      },
      removeTrapFocus(elementToFocus = null) {
        document.removeEventListener("focusin", this.listeners.focusin);
        document.removeEventListener("focusout", this.listeners.focusout);
        document.removeEventListener("keydown", this.listeners.keydown);
        if (elementToFocus) { elementToFocus.focus(); } else { this.activeElement?.focus(); }
      }
    });

    Alpine.data('xTruncateText', () => ({
      truncateEl: "", truncateInnerEl: "", truncated: false, truncatable: false, label: "", expanded: false,
      load(truncateEl) { const truncateRect = truncateEl.getBoundingClientRect(); truncateEl.style.setProperty("--truncate-height", `${truncateRect.height}px`); },
      setTruncate(element) {
        if (element.offsetHeight < element.scrollHeight || element.offsetWidth < element.scrollWidth) { this.truncated = true; this.truncatable = true; this.expanded = false; }
        else { this.truncated = false; this.truncatable = false; this.expanded = true; }
      },
      open(el, newLabel) {
        const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
        this.expanded = true; this.label = newLabel;
        if (truncateEl.classList.contains('truncate-expanded')) { this.truncated = true; }
        else {
          const truncateInnerEl = truncateEl.querySelector('.truncate-inner');
          window.requestAnimationFrame(() => {
            const truncateInnerRect = truncateInnerEl.getBoundingClientRect();
            truncateEl.style.setProperty("--truncate-height-expanded", `${truncateInnerRect.height}px`);
            truncateEl.classList.add('truncate-expanded');
          });
          this.truncated = false;
        }
      },
      close(el, newLabel, isPopup = false) {
        this.label = newLabel;
        const truncateEl = el.closest('.truncate-container').querySelector('.truncate-text');
        const isInViewport = () => { const rect = truncateEl.getBoundingClientRect(); return (rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth)); };
        this.truncated = true;
        if (!isInViewport()) {
          if (!isPopup) { window.scrollTo({ top: truncateEl.getBoundingClientRect().top + window.scrollY - 100, behavior: 'smooth' }); }
          else { const drawerContent = el.closest('.drawer__content'); drawerContent.scrollTo({ top: truncateEl.getBoundingClientRect().top + drawerContent.scrollTop - 100, behavior: 'smooth' }); }
          truncateEl.style.transition = 'none';
          setTimeout(() => { truncateEl.style.transition = ''; }, 1000);
        }
        truncateEl.classList.remove('truncate-expanded');
        this.expanded = false;
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xQuantitySelector", (sectionId, currentVariantId, productUrl, isQtyPriceBreak = false) => ({
      qty: 1, currentVariantId: currentVariantId,
      handleInit() {
        if (this.$refs.quantity_input && this.$refs.quantity_input.value) { this.qty = this.$refs.quantity_input.value; }
        document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${sectionId}`, (event) => {
          const {currentVariant} = event.detail;
          if (currentVariant && currentVariant.id) { this.currentVariantId = currentVariant.id; }
          if (this.$refs.qty_variant_in_cart) { this.$refs.qty_variant_in_cart.dataset.currentVariantId = this.currentVariantId; }
          if (this.$refs.quantity_input) { this.$refs.quantity_input.value = 1; }
          this.qty = 1;
        });
        document.addEventListener(`${CART_EVENT.cartUpdate}`, () => {
          fetch(`${productUrl}?variant=${this.currentVariantId}&section_id=${sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const oldElement = document.querySelector(`.section--${sectionId} .quantity-selector__quantity-in-cart[data-current-variant-id="${this.currentVariantId}"]`);
              const newElement = html.querySelector(`.section--${sectionId} .quantity-selector__quantity-in-cart[data-current-variant-id="${this.currentVariantId}"]`);
              if (oldElement && newElement) { oldElement.innerHTML = newElement.innerHTML; }
            }).catch((e) => console.error(e));
        });
        if (isQtyPriceBreak) {
          document.addEventListener(`volume-pricing-changed-${sectionId}`, (event) => {
            this.qty = event.detail.quantity;
            this.$refs.quantity_input.scrollIntoView({behavior: "smooth", block: "center"});
          });
        }
        this.$watch('qty', (newValue) => { if (this.$refs.quantity_input) { this.$refs.quantity_input.value = newValue; } });
      },
      minus(value) { this.qty = parseInt(this.qty); this.qty === 1 ? (this.qty = 1) : (this.qty -= value); },
      plus(value) { this.qty = parseInt(this.qty); this.qty += value; },
      invalid(el) { const number = parseFloat(el.value); if (!Number.isInteger(number) || number < 1) { this.qty = 1; } },
    }));

    Alpine.data("xSection", (sectionId, container) => ({
      sectionId: sectionId, loading: true, show_more: true,
      firstLoadData() {
        fetch(`${window.location.pathname}?section_id=${this.sectionId}`, { method: "GET" }).then((response) => response.text()).then(() => { this.loading = false; });
      },
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xQuantitySelectorAtc", (productId, index) => ({
      qty: 1, productId: productId, index: index,
      get quantityKey() { return `${this.productId}-${this.index}`; },
      init() {
        this.qty = Alpine.store('productQuantity').get(this.quantityKey);
        this.$watch(() => Alpine.store('productQuantity').get(this.quantityKey), (newValue) => { if (newValue !== this.qty) { this.qty = newValue; } });
        this.$watch('qty', (newValue) => { Alpine.store('productQuantity').set(this.quantityKey, newValue); this.updateWrapperDataset(newValue); });
      },
      updateWrapperDataset(newValue) { const wrapper = this.$el.closest('.product-card__wrapper'); if (wrapper) { wrapper.dataset.quantity = newValue; } },
      minus(value = 1) { this.qty = Math.max(1, this.qty - value); },
      plus(value = 1) { this.qty = this.qty + value; },
      invalid(el) { const number = parseFloat(el.value); if (!Number.isInteger(number) || number < 1) { this.qty = 1; } }
    }));

    Alpine.store('productQuantity', {
      quantities: {},
      set(key, value) { this.quantities[key] = Math.max(1, parseInt(value) || 1); },
      get(key) { return this.quantities[key] || 1; }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xSwiffy", {
      swiffySlider: null,
      load(el, configs) {
        this.swiffySlider = el;
        const swiffy = new SwiffySlider(el, configs);
        if (configs.handleArrow) { this.handleArrowButton(swiffy, el); }
        if (configs.hotspot) { this.handleHotspot(swiffy, configs); }
        if (configs.paginationBar) { this.handlePaginationBar(swiffy, configs); }
        if (configs.progressBar) { this.handleProgressBar(swiffy, configs); }
      },
      handleHotspot(swiffy, configs) {
        const hotspotRoot = document.getElementById(configs.hotspot);
        const hotspots = hotspotRoot.getElementsByClassName("x-hotspot");
        for (let i = 0; i < hotspots.length; i++) { hotspots[i].addEventListener("mouseenter", function (e) { swiffy.slideTo(i); }); }
        this.swiffySlider.addEventListener("maximize:swiffy-slider:slide", function (e) {
          const {oldActiveSlideIndex, newActiveSlideIndex} = e.detail;
          hotspots[oldActiveSlideIndex].classList.remove("active-hotspot");
          hotspots[newActiveSlideIndex].classList.add("active-hotspot");
        });
      },
      handleProgressBar(swiffy, configs) {
        let bar = swiffy.sliderElement.querySelector(".swiffy-slide-progress-bar");
        swiffy.sliderElement.addEventListener("maximize:swiffy-slider:slide", function (e) {
          const {oldActiveSlideIndex, newActiveSlideIndex} = e.detail;
          let end = configs.progressBar;
          let rate = 100 * (newActiveSlideIndex / end);
          if (bar) {
            let rateBar = rate + Number(bar.style.width.replace("%", ""));
            let maxRate = 100 - Number(bar.style.width.replace("%", ""));
            if (rateBar > 100) { rate = maxRate; }
            if (document.querySelector("body").classList.contains("rtl")) { bar.style.marginRight = rate + "%"; }
            else { bar.style.marginLeft = rate + "%"; }
          }
        });
      },
      handleArrowButton(swiffy, el) {
        const nextButton = el.querySelector(".arrow-next");
        const prevButton = el.querySelector(".arrow-prev");
        if (nextButton) { nextButton.addEventListener("click", function (e) { swiffy.slide(); }); }
        if (prevButton) { prevButton.addEventListener("click", function (e) { swiffy.slide(false); }); }
      },
      handlePaginationBar(swiffy, configs) {
        swiffy.sliderElement.addEventListener("maximize:swiffy-slider:slide", (event) => {
          const newActiveSlideIndex = Number(event.detail.newActiveSlideIndex);
          if (configs.paginationBar == "number_bar") {
            if (event.detail.el.querySelector(".current-active-index")) { event.detail.el.querySelector(".current-active-index").textContent = newActiveSlideIndex + 1; }
          } else if (configs.paginationBar == "image") {
            try {
              let imagePaginationList = event.detail.el.querySelectorAll(".pagination-active-image");
              let newActivePagination = newActiveSlideIndex < imagePaginationList.length - 1 ? newActiveSlideIndex + 1 : 0;
              imagePaginationList.forEach((imagePagination, index) => { imagePagination.classList.toggle("active", index === newActivePagination); });
            } catch (e) { console.error(e); }
          }
          this.handleLoadingProgress(event.detail.el, configs);
        });
      },
      handleLoadingProgress(el, configs) {
        if (configs.paginationBar == "image") {
          const overlay = el.querySelector('.pagination-image-ovelay');
          if (!overlay) return;
          overlay.classList.remove("active");
          overlay.restartTimeout = setTimeout(() => { overlay.classList.add("active"); }, 300);
        } else {
          const loadingEl = el.querySelector(".slider-autoplay-loading");
          if (!configs.autoPlay || !loadingEl) return;
          loadingEl.classList.remove("active");
          loadingEl.restartTimeout = setTimeout(() => { loadingEl.classList.add("active"); }, 300);
        }
      }
    });

    Alpine.store("xProductCard", {
      loadedChooseOptions: {},
      async loadChooseOptions(url, el, optionId, index, isShowQuantity = false) {
        const productCardWrapper = el.closest(".product-card__wrapper");
        if (!productCardWrapper) return;
        let listOptionValuesIdSelected = productCardWrapper.dataset.listOptionValuesIdSelected ? productCardWrapper.dataset.listOptionValuesIdSelected.split(",") : "";
        let urlProduct = `${url}?option_values=${listOptionValuesIdSelected}&section_id=choose-option&page=${index}`;
        let destinationElm = productCardWrapper.querySelector(".choose-option");
        let loadingEl = productCardWrapper.querySelector(".icon-loading");
        const renderQuantity = () => {
          const quantityContainer = destinationElm.querySelector('#ChooseOptionQuantity');
          if (isShowQuantity) { if (quantityContainer) { quantityContainer.classList.remove('hidden'); } }
          else { if (quantityContainer) { quantityContainer.remove(); } }
        };
        if (this.loadedChooseOptions[urlProduct]) { destinationElm.innerHTML = this.loadedChooseOptions[urlProduct]; renderQuantity(); setTimeout(() => { this.focusChooseOption(destinationElm); }, 500); return true; }
        try {
          if (loadingEl) { loadingEl.classList.remove("hidden"); }
          const response = await fetch(urlProduct);
          const content = await response.text();
          const parser = new DOMParser();
          let parsedContent = parser.parseFromString(content, "text/html").getElementById("ChooseOptionContent").innerHTML;
          if (parsedContent) { if (destinationElm) { destinationElm.innerHTML = parsedContent; renderQuantity(); } if (!Shopify.designMode) { this.loadedChooseOptions[urlProduct] = parsedContent; } }
          if (loadingEl) { loadingEl.classList.add("hidden"); }
        } catch (error) { console.error(error); }
        this.focusChooseOption(destinationElm);
      },
      focusChooseOption(el) { const closeButton = el.querySelector(".btn-close-choose-option"); if (closeButton) { closeButton.focus({ preventScroll: true }); } },
      handleCardHover(el) {
        const swiffy = new SwiffySlider(el, {});
        let cardImage = swiffy.sliderElement.querySelector(".slider-container");
        if (window.innerWidth >= MIN_DEVICE_WIDTH.desktop) {
          let mouseMoveRafId, mouseLeaveRafId;
          const onMouseMove = (e) => {
            if (mouseMoveRafId) cancelAnimationFrame(mouseMoveRafId);
            mouseMoveRafId = requestAnimationFrame(() => {
              let left = e.offsetX;
              let width = cardImage.getBoundingClientRect().width;
              if (window.Maximize.rtl) { left = width - left; }
              let spacing = left / width;
              let index = Math.floor(spacing * swiffy.slides.length);
              swiffy.dispatchEventSlide(swiffy.activeSlideIndex);
              swiffy.updateActiveSlide(index);
            });
          };
          const onMouseLeave = () => {
            if (mouseLeaveRafId) cancelAnimationFrame(mouseLeaveRafId);
            mouseLeaveRafId = requestAnimationFrame(() => { swiffy.dispatchEventSlide(swiffy.activeSlideIndex); swiffy.updateActiveSlide(0); });
          };
          cardImage.addEventListener("mousemove", onMouseMove);
          cardImage.addEventListener("mouseleave", onMouseLeave);
        }
      }
    });
  });
});


/* ============================================================
   PLEINE BULL — Search Engine v13 (custom xModalSearch)
   ============================================================ */

/* ── CSS ── */
(function() {
  if (document.getElementById("pb-css")) return;
  const s = document.createElement("style");
  s.id = "pb-css";
  s.textContent = `
#search-result { width:100% !important; max-width:100% !important; box-sizing:border-box !important; }
.pb-wrap{--r:#E30613;--n:#1B2A4A;--n06:rgba(27,42,74,.06);--n10:rgba(27,42,74,.09);--n20:rgba(27,42,74,.15);--n40:rgba(27,42,74,.4);--r08:rgba(227,6,19,.07);background:#fff;font-family:inherit;display:block;width:100% !important;max-width:100% !important;min-width:0 !important;box-sizing:border-box !important;overflow-x:hidden !important;padding:0 !important;margin:0 !important;}
.pb-inner{width:100%;max-width:100%;box-sizing:border-box;padding:8px 12px 6px;overflow-x:hidden;}
@media(min-width:768px){.pb-inner{padding:14px 20px 8px}}
.pb-chips{display:flex;flex-wrap:nowrap;gap:5px;overflow-x:auto;-webkit-overflow-scrolling:touch;scrollbar-width:none;padding-bottom:2px}
.pb-chips::-webkit-scrollbar{display:none}
@media(min-width:768px){.pb-chips{flex-wrap:wrap;overflow-x:visible}}
.pb-chip{display:inline-flex;align-items:center;padding:5px 11px;border-radius:999px;font-size:11.5px;font-weight:600;background:var(--n06);color:var(--n);border:1.5px solid var(--n20);text-decoration:none;white-space:nowrap;flex-shrink:0;line-height:1.4;transition:background .14s,color .14s}
.pb-chip:hover,.pb-chip:active{background:var(--n);color:#fff;border-color:var(--n)}
.pb-shortcuts{padding-bottom:10px;border-bottom:1px solid var(--n10)}
.pb-products{margin:10px 0 0}
.pb-section-hd{display:flex;align-items:center;justify-content:space-between;margin-bottom:8px}
.pb-section-title{display:flex;align-items:center;gap:6px;font-size:13px;font-weight:700;color:var(--n)}
.pb-bar{display:inline-block;width:3px;height:14px;border-radius:3px;background:var(--r);flex-shrink:0}
.pb-count{font-size:10px;color:var(--n40);font-weight:500}
.pb-grid{display:grid !important;grid-template-columns:repeat(2,1fr) !important;gap:8px;width:100% !important;box-sizing:border-box !important;}
@media(min-width:540px){.pb-grid{grid-template-columns:repeat(3,1fr) !important}}
@media(min-width:1024px){.pb-grid{grid-template-columns:repeat(6,1fr) !important;gap:10px !important}}
.pb-c{background:#fff;border-radius:8px;overflow:hidden;display:flex;flex-direction:column;position:relative;transition:box-shadow .2s;min-width:0}
.pb-c:hover{box-shadow:0 4px 16px rgba(0,0,0,.09)}
.pb-c-link{text-decoration:none;color:inherit;display:flex;flex-direction:column;height:100%}
.pb-c-img-wrap{position:relative;width:100%;padding-bottom:100%;background:#f5f5f5;border-radius:8px;overflow:hidden}
.pb-c-img{position:absolute;top:0;left:0;width:100%;height:100%;object-fit:contain;padding:5px}
.pb-c-img-ph{position:absolute;top:0;left:0;width:100%;height:100%;background:linear-gradient(135deg,#eef0f3,#e2e4e8)}
.pb-c-badges{position:absolute;top:4px;left:4px;display:flex;flex-direction:column;gap:2px;z-index:2}
.pb-b{display:inline-flex;align-items:center;padding:2px 5px;border-radius:3px;font-size:8px;font-weight:800;line-height:1.5}
.pb-b-steel{background:var(--n);color:#fff}
.pb-b-soft{background:#1565c0;color:#fff}
.pb-c-atc{position:absolute;bottom:5px;right:5px;opacity:0;transition:opacity .18s;z-index:2}
.pb-c:hover .pb-c-atc{opacity:1}
@media(hover:none){.pb-c-atc{opacity:1}}
.pb-c-atc-btn{display:flex;align-items:center;justify-content:center;width:30px;height:30px;border-radius:50%;background:var(--n);color:#fff;border:none;cursor:pointer}
.pb-c-body{padding:5px 4px 7px;display:flex;flex-direction:column;gap:2px;flex:1;min-width:0}
.pb-c-vendor{font-size:8px;font-weight:700;letter-spacing:.07em;text-transform:uppercase;color:var(--n40);margin:0;line-height:1.2}
.pb-c-title{font-size:11px;font-weight:600;color:var(--n);line-height:1.3;margin:0;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
@media(min-width:768px){.pb-c-title{font-size:12px}}
.pb-c-price-wrap{margin-top:auto;padding-top:4px}
.pb-c-price{font-size:12px;font-weight:700;color:var(--n);display:block}
@media(min-width:768px){.pb-c-price{font-size:14px}}
.pb-c-price-sale{color:var(--r)}
.pb-c-price-was{font-size:9px;color:var(--n40);font-weight:400;text-decoration:line-through}
.pb-voir-tous{margin:12px 0 0;text-align:center}
.pb-btn-all{display:inline-flex;align-items:center;gap:7px;padding:9px 24px;border-radius:8px;background:var(--n);color:#fff;font-size:12.5px;font-weight:700;text-decoration:none;border:2px solid var(--n);transition:background .15s,color .15s;cursor:pointer}
.pb-btn-all:hover,.pb-btn-all:active{background:#fff;color:var(--n)}
.pb-nores{text-align:center;padding:24px 16px}
.pb-nores-icon{font-size:28px;margin-bottom:8px}
.pb-nores-title{font-size:14px;font-weight:700;color:var(--n);margin:0 0 4px}
.pb-nores-hint{font-size:12px;color:var(--n40);margin:0}
.pb-extra-section{margin-top:12px;padding-top:10px;border-top:1px solid var(--n10)}
.pb-col-scroll{display:flex;flex-wrap:wrap;gap:6px;margin-top:6px}
.pb-col-card{display:inline-flex;align-items:center;gap:5px;padding:6px 13px;border-radius:999px;font-size:11.5px;font-weight:600;color:var(--n);background:var(--n06);border:1.5px solid var(--n20);text-decoration:none;white-space:nowrap;flex-shrink:0;transition:background .14s,color .14s}
.pb-col-card:hover,.pb-col-card:active{background:var(--n);color:#fff}
.pb-col-arrow{flex-shrink:0;opacity:.4}
.pb-art-list{display:flex;flex-direction:column;gap:8px;margin-top:6px}
@media(min-width:768px){.pb-art-list{display:grid;grid-template-columns:repeat(2,1fr);gap:10px}}
.pb-art-card{display:flex;align-items:flex-start;gap:10px;text-decoration:none;color:inherit;padding:8px;border-radius:8px;border:1px solid var(--n10);transition:border-color .15s;box-sizing:border-box}
.pb-art-card:hover{border-color:var(--r);background:var(--r08)}
.pb-art-img-wrap{width:80px;flex-shrink:0}
.pb-art-img{width:100%;height:auto;border-radius:6px;display:block}
.pb-art-img-ph{width:80px;height:60px;border-radius:6px;background:#eef0f3;flex-shrink:0}
.pb-art-body{display:flex;flex-direction:column;gap:4px;min-width:0;flex:1}
.pb-art-date{font-size:9px;color:var(--n40);font-weight:600;text-transform:uppercase;letter-spacing:.06em}
.pb-art-title{font-size:13px;font-weight:700;color:var(--n);line-height:1.4;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}
.pb-explore{border-top:1px solid var(--n10);margin-top:10px;padding-top:10px;padding-bottom:4px}
.pb-suggest{position:absolute;top:calc(100% + 3px);left:0;right:0;background:#fff;border:1.5px solid var(--n10);border-radius:8px;box-shadow:0 8px 24px rgba(27,42,74,.12);z-index:9999;overflow:hidden;animation:pb-in .13s ease}
@keyframes pb-in{from{opacity:0;transform:translateY(-4px)}to{opacity:1;transform:translateY(0)}}
.pb-suggest__item{display:flex;align-items:center;gap:9px;width:100%;padding:9px 14px;background:none;border:none;cursor:pointer;font-size:13px;color:var(--n);text-align:left;border-bottom:1px solid var(--n06);transition:background .1s;font-family:inherit}
.pb-suggest__item:last-child{border-bottom:none}
.pb-suggest__item:hover,.pb-suggest__item:active{background:var(--r08)}
.pb-suggest__icon{color:var(--n40);flex-shrink:0}
.pb-suggest__arrow{color:rgba(27,42,74,.25);margin-left:auto;flex-shrink:0}
.pb-filters-bar{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:10px;flex-wrap:wrap}
.pb-filters-toggle{position:relative;display:inline-flex;align-items:center;gap:7px;padding:9px 16px;border-radius:8px;background:#fff;color:var(--n);border:1.5px solid var(--n20);font-size:13px;font-weight:700;cursor:pointer;transition:background .14s,color .14s}
.pb-filters-toggle:hover{background:var(--n06)}
.pb-filters-dot{position:absolute;top:-3px;right:-3px;width:9px;height:9px;border-radius:50%;background:var(--r)}
.pb-sort-select{padding:9px 14px;border-radius:8px;background:#fff;color:var(--n);border:1.5px solid var(--n20);font-size:13px;font-weight:600;cursor:pointer}
.pb-filters-panel{display:flex;flex-wrap:wrap;gap:22px;padding:16px;margin-bottom:14px;background:var(--n06);border:1px solid var(--n10);border-radius:10px}
.pb-filter-group{min-width:150px}
.pb-filter-label{font-size:11px;font-weight:800;text-transform:uppercase;letter-spacing:.06em;color:var(--n40);margin:0 0 8px}
.pb-filter-check{display:flex;align-items:center;gap:7px;font-size:13px;color:var(--n);padding:4px 0;cursor:pointer}
.pb-filter-check input{accent-color:var(--n);width:14px;height:14px;flex-shrink:0}
.pb-filter-count{color:var(--n40);font-size:11px}
.pb-filter-price{display:flex;align-items:center;gap:8px}
.pb-filter-price input{width:70px;padding:6px 8px;border-radius:6px;border:1.5px solid var(--n20);font-size:13px;color:var(--n)}
.pb-filters-reset{align-self:flex-end;padding:8px 14px;border-radius:8px;background:none;border:1.5px solid var(--r);color:var(--r);font-size:12.5px;font-weight:700;cursor:pointer;height:fit-content}
.pb-filters-reset:hover{background:var(--r08)}
`;
  document.head.appendChild(s);
})();

/* ── Bloquer submit formulaire recherche hors page search ── */
(function() {
  document.addEventListener("submit", function(e) {
    if (window.location.pathname.indexOf("/search") !== -1) return;
    var form = e.target;
    if (form && typeof form.getAttribute === "function") {
      var action = form.getAttribute("action") || "";
      if (action.indexOf("/search") !== -1) { e.preventDefault(); e.stopPropagation(); }
    }
  }, true);
})();

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xModalSearch", (type, desktopMaximumResults, mobileMaximumResults, productTypeSelected) => ({
      t: null,
      isFirstLoading: true,
      result: "",
      query: "",
      cachedResults: {},
      openResults: false,
      isFocusedSearchForm: false,
      showSuggest: false,
      loading: false,
      suggestions: [],
      productSuggestions: [],
      productLoading: false,
      productQuery: "",
      productRequestId: 0,

      init() {
        this.isFocusedSearchForm = false;
        this.openResults = false;
        this.showSuggest = true;
        this.productSuggestions = [];
        this.productLoading = false;
      },

      _isSP() { return window.location.pathname.indexOf("/search") !== -1; },

      _sugg: [
        "Fléchettes Bull's Blackjack laiton doré 20g","Fléchettes Bull's Kim Huybrechts 21g","Fléchettes Bull's Shark Pro noir 90% tungstène","Fléchettes Bull's Tank 22g","Fléchettes Bull's Thriller noir laiton 21g","Fléchettes acier Bull's Bronzo True 23g","Fléchettes acier Bull's Dirk van Duijvenbode 22g","Fléchettes acier Bull's Eagle 3 22g","Fléchettes acier Bull's Eagle 3 24g","Fléchettes acier Bull's Lightning Orange 23g","Fléchettes acier Bull's Lightning Rose 24g","Fléchettes acier Bull's Lightning Rouge 23g","Fléchettes acier Bull's Mario laiton 21g","Fléchettes acier Bull's Max Hopp 24g","Fléchettes acier Bull's Mercurius Ava 19g","Fléchettes acier Bull's Smoke Red Ember 23g","Fléchettes acier Jack Daniel's Old No7 laiton","Fléchettes acier Mission Horus 97,5% tungstène","Fléchettes acier Mission Josh Rock Brass Rocky laiton","Fléchettes acier Mission Lava 95% tungstène","Fléchettes acier Mission Scorpion 90% tungstène","Fléchettes acier Mission Venom 90% tungstène","Fléchettes acier Unicorn Gary Anderson Phase 6 90% Tungstène 22g",
        "Fléchettes soft tip Bull's Flora Zina 18g","Fléchettes soft tip Bull's Lightning Rose 19g","Fléchettes soft tip Bull's Lightning Rouge 21g","Fléchettes soft tip Bull's Phantom Grip 18g","Fléchettes soft tip Bull's Phantom Grip 22g","Fléchettes soft tip Bull's Roulette 18g","Fléchettes soft tip Bull's Shark Pro 20g","Fléchettes soft tip Jack Daniel's Old No7","Fléchettes soft tip Mission Horus 97,5% Tungstène 23g","Fléchettes soft tip Mission Josh Rock Rocky","Fléchettes soft tip Mission Lava 95% tungstène","Fléchettes soft tip Mission Nightfall M1 Straight Ring","Fléchettes soft tip Mission Scorpion 90% tungstène","Fléchettes soft tip Mission Venom 90% tungstène","Pack 3 jeux fléchettes Unicorn Converta acier et soft tip 17g",
        "fléchettes steel tip","fléchettes soft tip","fléchettes Mission","fléchettes Bull's","fléchettes Unicorn","fléchettes Jack Daniel's","fléchettes tungstène","fléchettes laiton","fléchettes 90%","fléchettes 95%","fléchettes 97%","fléchettes 18g","fléchettes 19g","fléchettes 20g","fléchettes 21g","fléchettes 22g","fléchettes 23g","fléchettes 24g","fléchettes 25g","fléchettes 26g","fléchettes noires","fléchettes rouges","fléchettes bleues","fléchettes vertes","fléchettes dorées","fléchettes argentées","fléchettes roses","fléchettes oranges","fléchettes débutant","fléchettes compétition",
        "Cible Winmau Blade 6","Cible Winmau Blade 6 Dual Core","Cible Winmau Blade 6 Triple Core Carbon","Cible de fléchettes Bull's Advantage 7.01 Pro","Cible de fléchettes Bull's The Classic","Cible de fléchettes Shot Michael Smith Competition","Cible de fléchettes Shot Rogue en sisal","Cible d'entraînement fléchettes Bull's Advantage Gold","Cible entraînement Unicorn Contender Trainer","Cible entraînement Unicorn HD Trainer","Cible fléchettes Unicorn Eclipse Pro","Cible fléchettes Unicorn Eclipse Pro 2","Cible fléchettes Unicorn Eclipse Ultra","Cible fléchettes Unicorn Eclipse Ultra 2.0","Cible fléchettes Unicorn Striker","Cible sisal Designa","Cible sisal Mission Samurai 4",
        "Cible électronique GRANBOARD 132","Cible électronique soft tip Unicorn LED avec 2 jeux de fléchettes","Cible sisal Jack Daniel's avec cabinet","Cible sisal Unicorn Striker avec cabinet",
        "cible sisal","cible électronique","cible Unicorn","cible Designa","cible Granboard","cible Bull's","cible Winmau","cible connectée","cible led","cible Blade 6",
        "Ailettes Mission Lava 100 microns Standard No6","Ailettes Mission Solo Horus 100 microns Standard No2","Ailettes Mission Solo Komodo 100 microns Standard No2","Ailettes Mission Solo Kuro 100 microns Standard No2","Ailettes Mission Solo Scorpion 100 microns Standard No2","Ailettes Mission Solo Venom 100 microns Standard No2","Ailettes Unicorn Ultrafly 75 AR1 Ghost Gary Anderson","Ailettes fléchettes Bull's Fortis 150 No.2","Ailettes fléchettes Bull's Mezzo 100 No.2","Ailettes fléchettes Bull's Phantom No.6","Ailettes fléchettes Bull's Piano 75 No.2","Ailettes fléchettes Bull's Retro 100 No.2","Ailettes fléchettes Robson Plus No.2",
        "ailettes standard","ailettes slim","ailettes No2","ailettes No6","ailettes Mission","ailettes Bull's","ailettes Unicorn","ailettes Robson","ailettes noires","ailettes rouges","ailettes bleues","ailettes vertes","ailettes oranges",
        "Tiges Mission Alicross Nylon","Tiges Mission Atom13 Aluminium","Tiges Mission Griplock","Tiges Mission Titan Fox titane","Tiges Unicorn Gripper 4","Tiges Bull's Alabama Short",
        "tiges courtes","tiges moyennes","tiges longues","tiges aluminium","tiges nylon","tiges titane","tiges Mission","tiges Bull's","tiges Unicorn",
        "Ailettes et tiges Mission Force Vortex No2","Ailettes et tiges Mission Force Vortex No6","Tiges et ailettes Bull's Union Pro","Tiges et ailettes Shot",
        "Pointes acier Bull's 32 mm","Pointes acier Bull's 38 mm","Pointes acier Bull's 45 mm","Pointes acier Bull's Osiris Grip","Pointes acier Unicorn Standard","Pointes de conversion Bull's","Pointes de fléchettes Mission Caliburn Ripple","Pointes de fléchettes Mission Glide","Pointes de fléchettes Mission Lasered","Pointes de fléchettes Mission Titan Pro Conversion",
        "pointes acier","pointes acier courtes","pointes acier longues","pointes de conversion",
        "Embouts soft tip Unicorn Epic noirs","Pointes de fléchettes Designa","Pointes de fléchettes Mission Titan Pro","Pointes de fléchettes Unicorn Spare Soft Tip","Pointes soft tip Bull's EVO","Pointes soft tip Bull's Long Life Short","Pointes soft tip Bull's Startip Short","pointes plastiques","pointes soft tip",
        "Etui fléchettes Mission Country EVA","Etui fléchettes Mission Freedom","Étui fléchettes Unicorn Vanguard","Étui pour fléchettes Bull's Lica 12","Étui pour fléchettes Bull's Morph","étui fléchettes","étui rigide","étui souple",
        "Anneau de protection cible Mission Surround Pro Heavy Duty","Anneau de protection de cible Bull's","Anneau de protection murale cible Unicorn Striker","Anneau de protection de cible Winmau","surround","anneau de protection cible",
        "Tapis de fléchettes Bull's Advantage","Tapis de fléchettes Bull's Illusion","Tapis fléchettes Unicorn Ultra 2.0","Tapis pro zone precision Winmau","tapis fléchettes",
        "Mission Torus 100 Eclairage cible led","Mission Torus 120 degres Eclairage cible","Système d'éclairage pour cible Bull's Lumo","Système d'éclairage pour cible Bull's Termote","Éclairage cible Winmau Polaris","éclairage cible","led cible",
        "Support fléchettes Mission Acrylic Arc","Support mural pour cible Bull's Click Fix","Ligne de tir autocollante Bull's Oche","Oche laser Viper","Extracteur de pointes Trinidad Shark","Aiguiseur de pointes Mission",
        "Mission","Bull's","Unicorn","Designa","Granboard","Shot","Winmau","Jack Daniel's","Trinidad","Robson","Viper",
      ],

      _CAT: {
        steel:["Steel Tip"],soft:["Soft Tip"],flechette:["Steel Tip","Soft Tip"],
        cible:["Cibles Sisal","Cibles électroniques","Cabinet"],ailette:["Ailettes","Fusion Ailettes Tiges"],
        tige:["Tiges","Fusion Ailettes Tiges"],"pointe acier":["Pointes acier"],"pointe soft":["Pointes plastiques"],
        pointe:["Pointes acier","Pointes plastiques"],etui:["Etuis"],tapis:["Tapis"],surround:["Surround"],pack:["Pack"],eclairage:["Eclairage"],
      },

      _norm(str) { return (str||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9 ]/g," ").replace(/\s+/g," ").trim(); },

      _colorMap: {"verte":"vert","vertes":"vert","rouge":"rouge","rouges":"rouge","bleue":"bleu","bleues":"bleu","noire":"noir","noires":"noir","rose":"rose","roses":"rose","jaune":"jaune","jaunes":"jaune","orange":"orange","oranges":"orange","doree":"dore","dorees":"dore","doré":"dore","dorée":"dore","dorées":"dore","dores":"dore","argentee":"argent","argentees":"argent","argentée":"argent","argentées":"argent","violette":"violet","violettes":"violet","blanche":"blanc","blanches":"blanc","grise":"gris","grises":"gris","bronze":"bronze","bronzee":"bronze","titane":"titane","titan":"titane","tungstene":"tungstene","tungsten":"tungstene","laiton":"laiton","brass":"laiton"},

      _cat(query) {
        const q = this._norm(query);
        if (q.includes("pointe acier")||q.includes("pointes acier")) return "pointe acier";
        if (q.includes("pointe plastique")||q.includes("pointe soft")||q.includes("pointes plastiques")) return "pointe soft";
        if (q.includes("soft tip")) return "soft";
        if (q.includes("steel tip")) return "steel";
        if (q.includes("etui")||q.includes("sacoche")||q.includes("trousse")) return "etui";
        if (q.includes("pointe")) return "pointe";
        if (/^fl/.test(q)||q.includes("flechette")||q.includes("dart")) return "flechette";
        if (q.includes("soft")&&!q.includes("flechette")) return "soft";
        if (q.includes("steel")&&!q.includes("flechette")) return "steel";
        if (q.includes("cible")||q.includes("board")||q.includes("sisal")||q.includes("dartboard")||q.includes("cabinet")||q.includes("armoire")) return "cible";
        if (q.includes("ailette")||q.includes("flight")||q.includes("vol")) return "ailette";
        if (q.includes("tige")||q.includes("shaft")) return "tige";
        if (q.includes("tapis")) return "tapis";
        if (q.includes("surround")||q.includes("anneau")) return "surround";
        if (q.includes("eclairage")||q.includes("led")) return "eclairage";
        if (q.includes("pack")||q.includes("kit")||q.includes("coffret")) return "pack";
        return null;
      },

      _normalizeQuery(query) { const q = this._norm(query); return q.split(" ").map(w => this._colorMap[w] || w).join(" "); },

      _fuzzy(query) {
        const q = this._norm(query);
        const set = new Set([query, q]);
        const fixes = {"fl":"flechette","fle":"flechette","flec":"flechette","flech":"flechette","fleche":"flechette","flechett":"flechette","flechete":"flechette","flechetes":"flechette","flechettes":"flechette","flchette":"flechette","flchettes":"flechette","flechtte":"flechette","dart":"flechette","darts":"flechette","ci":"cible","cib":"cible","cibl":"cible","cibles":"cible","dartboard":"cible","board":"cible","sisal":"cible sisal","armoire":"cabinet","armoires":"cabinet","ai":"ailette","ail":"ailette","aile":"ailette","ailtte":"ailette","ailetes":"ailette","ailettes":"ailette","fli":"flight","fligh":"flight","flights":"flight","ti":"tige","tig":"tige","tge":"tige","tiges":"tige","sha":"shaft","shaf":"shaft","shafts":"shaft","poi":"pointe","poin":"pointe","point":"pointe","pointes":"pointe","etu":"etui","etuit":"etui","etuis":"etui","sacoche":"etui","trousse":"etui","tap":"tapis","tapi":"tapis","sur":"surround","surr":"surround","anneau":"surround","bul":"bulls","bull":"bulls","buls":"bulls","unicor":"unicorn","mision":"mission","missoin":"mission","harows":"harrows","harrow":"harrows","designas":"designa","dezigna":"designa","granboar":"granboard","granbord":"granboard","winmaux":"winmau","winmo":"winmau"};
        const fixed = fixes[q]; if (fixed) set.add(fixed);
        const dedupe = q.replace(/(.)\1+/g,"$1");
        if (dedupe !== q) { set.add(dedupe); if (fixes[dedupe]) set.add(fixes[dedupe]); }
        if (q.length > 3) { const t=q.slice(0,-1); set.add(t); if (fixes[t]) set.add(fixes[t]); }
        const normalized = this._normalizeQuery(q);
        if (normalized !== q) set.add(normalized);
        const words = q.split(" ");
        const withoutColor = words.filter(w => !this._colorMap[w]).join(" ").trim();
        if (withoutColor && withoutColor !== q && withoutColor.length > 1) set.add(withoutColor);
        return [...set].filter(v => v.length >= 2).slice(0,6);
      },

      _updateSugg(q) {
        if (!q || q.length < 2) { this.suggestions = []; return; }
        const qn = this._norm(q);
        const qNorm = this._normalizeQuery(qn);
        const words = qn.split(" ").filter(w => w.length > 0);
        this.suggestions = this._sugg.filter(s => {
          const sn = this._norm(s);
          if (sn === qn || sn === qNorm) return false;
          const allWords = words.every(w => sn.includes(w));
          const lastWord = words[words.length - 1];
          const otherWords = words.slice(0, -1);
          const partialMatch = otherWords.every(w => sn.includes(w)) && sn.split(" ").some(sw => sw.startsWith(lastWord));
          return allWords || partialMatch || sn.includes(qNorm);
        }).slice(0,6);
      },

      _productImage(p) {
        const raw = p?.featured_image?.url || p?.image?.url || p?.image || "";
        if (!raw) return "";
        return raw + (raw.includes("?") ? "&" : "?") + "width=160";
      },

      _formatPrice(value) {
        const price = parseFloat(value || "0");
        if (!price) return "";
        return price.toFixed(2).replace(".", ",") + "\u00a0€";
      },

      _productUrl(p) {
        return p?.url || (p?.handle ? "/products/" + p.handle : "#");
      },

      async _loadProductSuggestions(query) {
        const q = (query || "").trim();
        clearTimeout(this.t);

        if (q.length < 2) {
          this.productSuggestions = [];
          this.productLoading = false;
          this.productQuery = "";
          return;
        }

        const requestId = ++this.productRequestId;
        this.productLoading = true;
        this.productQuery = q;

        this.t = setTimeout(async () => {
          const products = await this._fetchProducts(q);

          if (requestId !== this.productRequestId || this.query.trim() !== q) return;

          this.productSuggestions = products
            .map((product, index) => ({
              product,
              index,
              score: this._score(product, q)
            }))
            .sort((a, b) => (b.score - a.score) || (a.index - b.index))
            .slice(0, 5)
            .map(item => item.product);

          this.productLoading = false;
        }, 220);
      },

      _goSearch(query) {
        if (!query || query.length < 1) return;
        const normalized = this._normalizeQuery(query);
        const cat = this._cat(normalized);
        const types = cat ? this._CAT[cat] : null;
        let url = '/search?q=' + encodeURIComponent(normalized) + '&type=product';
        if (types) url += types.map(t => '&filter.p.product_type=' + encodeURIComponent(t)).join('');
        window.location.href = url;
      },

      async _fetch(q) {
        try {
          const r = await fetch(Shopify.routes.root + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=20");
          const d = await r.json();
          return d.resources?.results?.products || [];
        } catch(e) { return []; }
      },

      async _fetchProducts(query) {
        const cat = this._cat(query);
        const variants = this._fuzzy(query);
        const types = cat ? this._CAT[cat] : null;
        const reqs = variants.map(v => this._fetch(v));
        if (types) { types.forEach(ty => { reqs.push(this._fetch((variants[0]||query) + " product_type:" + ty)); }); }
        const volumeQueries = {
          flechette:["flechettes","flechettes steel tip","flechettes soft tip","flechettes bulls","flechettes unicorn","flechettes mission","flechettes harrows","flechettes shot","flechettes designa","flechettes tungstene","flechettes laiton"],
          cible:["cible sisal","cible electronique","cible flechettes","cible unicorn","cible designa","dartboard","cible bulls"],
          ailette:["ailettes flechettes","ailettes bulls","ailettes mission","ailettes unicorn","ailettes slim","ailettes standard"],
          tige:["tiges flechettes","tiges aluminium","tiges nylon","tiges bulls","tiges mission","shafts darts"],
          pointe:["pointes acier","pointes plastiques","pointes flechettes","tips darts"],
          etui:["etui flechettes","etui darts","sac flechettes"],
          tapis:["tapis flechettes","tapis dartboard","mat darts"],
        };
        if (cat && volumeQueries[cat]) { volumeQueries[cat].forEach(vq => reqs.push(this._fetch(vq))); }
        const seen = new Set(); const out = [];
        const merge = list => { for (const p of list) if (!seen.has(p.handle)) { seen.add(p.handle); out.push(p); } };
        (await Promise.all(reqs)).forEach(merge);
        if (types) {
          const filtered = out.filter(p => types.includes(p.type));
          if (filtered.length > 0) return filtered;
          return out.filter(p => !["Etuis","Entretien","Accessoires","Tapis","Eclairage","Surround"].includes(p.type));
        }
        return out;
      },

      _score(p, query) {
        const q = this._norm(query);
        const t = this._norm(p.title||"");
        let sc = 0;
        if (t.startsWith(q)) sc += 20;
        else if (t.includes(q)) sc += 10;
        else if (t.split(" ").some(w => w.startsWith(q))) sc += 5;
        if (t.includes("22g")||t.includes("23g")||t.includes("24g")) sc += 2;
        return sc;
      },

      async _fetchExtras(query) {
        const qn = this._norm(query);
        try {
          const [artR, colR] = await Promise.all([
            fetch(Shopify.routes.root + "search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=article&resources[limit]=6").then(r => r.json()).catch(() => ({})),
            fetch(Shopify.routes.root + "search/suggest.json?q=" + encodeURIComponent(query) + "&resources[type]=collection&resources[limit]=10").then(r => r.json()).catch(() => ({}))
          ]);
          const cols = colR.resources?.results?.collections || [];
          cols.sort((a,b) => { const ta=this._norm(a.title||""),tb=this._norm(b.title||""); return (ta.startsWith(qn)?0:ta.includes(qn)?1:2)-(tb.startsWith(qn)?0:tb.includes(qn)?1:2); });
          return { collections: cols.slice(0,8), articles: (artR.resources?.results?.articles||[]).slice(0,6) };
        } catch(e) { return {collections:[],articles:[]}; }
      },

      _card(p) {
        const pr = parseFloat(p.price||"0");
        const price = pr > 0 ? pr.toFixed(2).replace(".",",")+"\u00a0€" : "";
        const cp = parseFloat(p.compare_at_price_min||"0");
        const was = cp > pr ? cp.toFixed(2).replace(".",",")+"\u00a0€" : null;
        const img = (p.featured_image?.url||p.image) ? (p.featured_image?.url||p.image)+"&width=400" : null;
        const tags = (p.tags||[]).map(t=>(t||"").toLowerCase());
        const steel = p.type==="Steel Tip"||tags.some(t=>t.includes("steel tip"));
        const soft = p.type==="Soft Tip"||tags.some(t=>t.includes("soft tip"));
        const url = p.url||"/products/"+p.handle;
        const vid = p.variants?.[0]?.id||0;
        return `<div class="pb-c"><a href="${url}" class="pb-c-link"><div class="pb-c-img-wrap">${img?`<img src="${img}" alt="${(p.title||"").replace(/"/g,"&quot;")}" loading="lazy" class="pb-c-img">`:`<div class="pb-c-img-ph"></div>`}<div class="pb-c-badges">${steel?`<span class="pb-b pb-b-steel">⚙ Steel</span>`:""}${soft?`<span class="pb-b pb-b-soft">● Soft</span>`:""}</div>${vid?`<div class="pb-c-atc"><button class="pb-c-atc-btn" onclick="event.preventDefault();event.stopPropagation();var f=document.createElement('form');f.method='POST';f.action='/cart/add';var i=document.createElement('input');i.type='hidden';i.name='id';i.value='${vid}';f.appendChild(i);document.body.appendChild(f);f.submit();" title="Ajouter au panier"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></button></div>`:""}</div><div class="pb-c-body">${p.vendor?`<p class="pb-c-vendor">${p.vendor}</p>`:""}<h3 class="pb-c-title">${p.title||""}</h3><div class="pb-c-price-wrap"><span class="pb-c-price${was?" pb-c-price-sale":""}">${price}</span>${was?`<span class="pb-c-price-was">${was}</span>`:""}</div></div></a></div>`;
      },
      _cardCol(c) { return `<a href="${c.url}" class="pb-col-card"><span>${c.title||""}</span><svg class="pb-col-arrow" width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6h8M7 3l3 3-3 3" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg></a>`; },
      _cardArt(a) {
        const img = a.image||null;
        const date = a.published_at ? new Date(a.published_at).toLocaleDateString("fr-FR",{day:"2-digit",month:"short"}) : "";
        return `<a href="${a.url}" class="pb-art-card"><div class="pb-art-img-wrap">${img?`<img src="${img}" alt="${(a.title||"").replace(/"/g,"&quot;")}" loading="lazy" class="pb-art-img">`:`<div class="pb-art-img-ph"></div>`}</div><div class="pb-art-body"><span class="pb-art-date">${date}</span><span class="pb-art-title">${a.title||""}</span></div></a>`;
      },

      _render(products, query, extras) {
        const qE = encodeURIComponent(query);
        const root = (Shopify.routes.root||"/").replace(/\/$/,"");
        const {collections=[],articles=[]} = extras||{};
        const chips = [["Fléchettes","fl%C3%A9chettes"],["Soft tip","soft%20tip"],["Steel tip","steel%20tip"],["Cibles","cible"],["Étuis","%C3%A9tui"],["Shafts","shaft"],["Flights","flight"]].map(([l,s])=>`<a href="${root}/search?q=${s}&type=product" class="pb-chip">${l}</a>`).join("");
        const explore = [["+ Rouge",`${qE}%20rouge`],["+ 22g",`${qE}%2022g`],["+ Soft",`${qE}%20soft%20tip`],["+ Steel",`${qE}%20steel%20tip`],["Bull's",`bulls%20${qE}`],["Mission",`mission%20${qE}`]].map(([l,q])=>`<a href="${root}/search?q=${q}&type=product" class="pb-chip">${l}</a>`).join("");
        const cat = this._cat(query);
        const filterParam = (cat==="flechette")?"&filter.p.product_type=Steel+Tip&filter.p.product_type=Soft+Tip":(cat==="cible")?"&filter.p.product_type=Cibles+Sisal&filter.p.product_type=Cibles+%C3%A9lectroniques":(cat==="ailette")?"&filter.p.product_type=Ailettes":(cat==="tige")?"&filter.p.product_type=Tiges":(cat==="pointe")?"&filter.p.product_type=Pointes+acier&filter.p.product_type=Pointes+plastiques":(cat==="etui")?"&filter.p.product_type=Etuis":"";
        const n = products.length;
        const voir = `<div class="pb-voir-tous"><a href="${root}/search?q=${qE}&type=product${filterParam}" class="pb-btn-all">Voir tous les résultats <svg width="13" height="13" viewBox="0 0 13 13" fill="none"><path d="M2 6.5h9M8 3l3.5 3.5L8 10" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></a></div>`;
        const cards = n > 0 ? `<div class="pb-products"><div class="pb-section-hd"><span class="pb-section-title"><span class="pb-bar"></span>Produits</span><span class="pb-count">${n} résultat${n>1?"s":""}</span></div><div class="pb-grid">${products.map(p=>this._card(p)).join("")}</div>${voir}</div>` : `<div class="pb-nores"><div class="pb-nores-icon">🎯</div><p class="pb-nores-title">Aucun résultat pour "${query}"</p><p class="pb-nores-hint">Essaie une marque, un poids ou une couleur.</p></div>${voir}`;
        const colH = collections.length ? `<div class="pb-extra-section"><span class="pb-lbl">Collections</span><div class="pb-col-scroll">${collections.map(c=>this._cardCol(c)).join("")}</div></div>` : "";
        const artH = articles.length ? `<div class="pb-extra-section"><span class="pb-lbl">Articles du blog</span><div class="pb-art-list">${articles.map(a=>this._cardArt(a)).join("")}</div></div>` : "";
        return `<div class="pb-wrap"><div class="pb-inner"><div class="pb-shortcuts"><span class="pb-lbl">Accès rapide</span><div class="pb-chips">${chips}</div></div>${cards}${colH}${artH}<div class="pb-explore"><span class="pb-lbl">Explorer aussi</span><div class="pb-chips">${explore}</div></div></div></div>`;
      },

      async getSearchResult(query) { this._goSearch(query); },

      applySuggestion(s) {
        this.query = s;
        this.suggestions = [];
        this.productSuggestions = [];
        this.productLoading = false;
        this.showSuggest = false;
        if (this.$refs.input_search) { this.$refs.input_search.value = s; this.$refs.input_search.blur(); }
        this._goSearch(s);
      },

      open() {
        this.isFocusedSearchForm = true;
        this.showSuggest = true;
        setTimeout(() => { if (this.$refs.input_search) this.$refs.input_search.focus(); }, 50);
      },

      close() {
        this.isFocusedSearchForm = false;
        this.openResults = false;
        this.suggestions = [];
        this.productSuggestions = [];
        this.productLoading = false;
        this.productRequestId++;
      },

      handleChangeInput() {
        this.query = this.$el.value;
        this._updateSugg(this.query);
        this._loadProductSuggestions(this.query);
        if (this.query.length === 0) {
          this.showSuggest = true;
          this.suggestions = [];
          this.productSuggestions = [];
        }
      },

      focusForm() {
        this.isFocusedSearchForm = true;
        this.showSuggest = true;
        const input = this.$refs.input_search;
        const v = this.query || input?.value || "";
        if (v.length >= 2) {
          if (input) { input.value = v; input.select(); }
          this._updateSugg(v);
          this._loadProductSuggestions(v);
        } else {
          if (input) input.value = "";
          this.query = "";
          this.suggestions = [];
          this.productSuggestions = [];
          this.productLoading = false;
        }
      },

      handleKeyUpModal(event) {
        if (["Escape","Tab","Shift","Control","Alt","Meta","ArrowUp","ArrowDown"].includes(event.key)) {
          if (event.key === "Escape") {
            this.suggestions = [];
            this.productSuggestions = [];
            this.productLoading = false;
            this.productRequestId++;
          }
          return;
        }
        if (event.key === "Enter") {
          this.suggestions = [];
          if (this.$refs.input_search) this.$refs.input_search.blur();
          event.preventDefault();
          event.stopImmediatePropagation();
          clearTimeout(this.t);
          const q = this.query || event.target.value || "";
          if (q.length >= 1) this._goSearch(q);
          return;
        }
        this.query = event.target.value;
        this._updateSugg(this.query);
        this._loadProductSuggestions(this.query);
        if (this.query.length === 0) {
          this.showSuggest = true;
          this.suggestions = [];
          this.productSuggestions = [];
        }
      },

      setSearchBoxHeight() {
        Alpine.nextTick(() => {
          if (this.$refs.search_content) {
            const rect = this.$refs.search_content.getBoundingClientRect();
            if (rect.top > 0) this.$refs.search_content.style.setProperty("--input-search-to-top", `${rect.top}px`);
          }
        });
      },

      /* Stub pour compatibilité Vast (appelé par le nouveau header-search.liquid) */
      fetchRefinedSearch() {},
      setProductType() {},
      handleChangeProductType() {},
    }));

    Alpine.data("xSearchPageResults", (initialQuery) => ({
      query: initialQuery || "",
      loading: true,
      products: [],
      visibleCount: 24,
      pageSize: 24,
      showFilters: false,
      sortBy: "pertinence",
      filters: { vendors: [], types: [], colors: [], inStock: false, minPrice: "", maxPrice: "" },

      init() {
        this._runSearch();
      },

      _norm(str) { return (str||"").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g,"").replace(/[^a-z0-9 ]/g," ").replace(/\s+/g," ").trim(); },

      _colorMap: {"verte":"vert","vertes":"vert","rouge":"rouge","rouges":"rouge","bleue":"bleu","bleues":"bleu","noire":"noir","noires":"noir","rose":"rose","roses":"rose","jaune":"jaune","jaunes":"jaune","orange":"orange","oranges":"orange","doree":"dore","dorees":"dore","doré":"dore","dorée":"dore","dorées":"dore","dores":"dore","argentee":"argent","argentees":"argent","argentée":"argent","argentées":"argent","violette":"violet","violettes":"violet","blanche":"blanc","blanches":"blanc","grise":"gris","grises":"gris","bronze":"bronze","bronzee":"bronze","titane":"titane","titan":"titane","tungstene":"tungstene","tungsten":"tungstene","laiton":"laiton","brass":"laiton"},

      _CAT: {
        steel:["Steel Tip"],soft:["Soft Tip"],flechette:["Steel Tip","Soft Tip"],
        cible:["Cibles Sisal","Cibles électroniques","Cabinet"],ailette:["Ailettes","Fusion Ailettes Tiges"],
        tige:["Tiges","Fusion Ailettes Tiges"],"pointe acier":["Pointes acier"],"pointe soft":["Pointes plastiques"],
        pointe:["Pointes acier","Pointes plastiques"],etui:["Etuis"],tapis:["Tapis"],surround:["Surround"],pack:["Pack"],eclairage:["Eclairage"],
      },

      _normalizeQuery(query) { const q = this._norm(query); return q.split(" ").map(w => this._colorMap[w] || w).join(" "); },

      _cat(query) {
        const q = this._norm(query);
        if (q.includes("pointe acier")||q.includes("pointes acier")) return "pointe acier";
        if (q.includes("pointe plastique")||q.includes("pointe soft")||q.includes("pointes plastiques")) return "pointe soft";
        if (q.includes("soft tip")) return "soft";
        if (q.includes("steel tip")) return "steel";
        if (q.includes("etui")||q.includes("sacoche")||q.includes("trousse")) return "etui";
        if (q.includes("pointe")) return "pointe";
        if (/^fl/.test(q)||q.includes("flechette")||q.includes("dart")) return "flechette";
        if (q.includes("soft")&&!q.includes("flechette")) return "soft";
        if (q.includes("steel")&&!q.includes("flechette")) return "steel";
        if (q.includes("cible")||q.includes("board")||q.includes("sisal")||q.includes("dartboard")||q.includes("cabinet")||q.includes("armoire")) return "cible";
        if (q.includes("ailette")||q.includes("flight")||q.includes("vol")) return "ailette";
        if (q.includes("tige")||q.includes("shaft")) return "tige";
        if (q.includes("tapis")) return "tapis";
        if (q.includes("surround")||q.includes("anneau")) return "surround";
        if (q.includes("eclairage")||q.includes("led")) return "eclairage";
        if (q.includes("pack")||q.includes("kit")||q.includes("coffret")) return "pack";
        return null;
      },

      _fuzzy(query) {
        const q = this._norm(query);
        const set = new Set([query, q]);
        const fixes = {"fl":"flechette","fle":"flechette","flec":"flechette","flech":"flechette","fleche":"flechette","flechett":"flechette","flechete":"flechette","flechetes":"flechette","flechettes":"flechette","flchette":"flechette","flchettes":"flechette","flechtte":"flechette","dart":"flechette","darts":"flechette","ci":"cible","cib":"cible","cibl":"cible","cibles":"cible","dartboard":"cible","board":"cible","sisal":"cible sisal","armoire":"cabinet","armoires":"cabinet","ai":"ailette","ail":"ailette","aile":"ailette","ailtte":"ailette","ailetes":"ailette","ailettes":"ailette","fli":"flight","fligh":"flight","flights":"flight","ti":"tige","tig":"tige","tge":"tige","tiges":"tige","sha":"shaft","shaf":"shaft","shafts":"shaft","poi":"pointe","poin":"pointe","point":"pointe","pointes":"pointe","etu":"etui","etuit":"etui","etuis":"etui","sacoche":"etui","trousse":"etui","tap":"tapis","tapi":"tapis","sur":"surround","surr":"surround","anneau":"surround","bul":"bulls","bull":"bulls","buls":"bulls","unicor":"unicorn","mision":"mission","missoin":"mission","harows":"harrows","harrow":"harrows","designas":"designa","dezigna":"designa","granboar":"granboard","granbord":"granboard","winmaux":"winmau","winmo":"winmau"};
        const fixed = fixes[q]; if (fixed) set.add(fixed);
        const dedupe = q.replace(/(.)\1+/g,"$1");
        if (dedupe !== q) { set.add(dedupe); if (fixes[dedupe]) set.add(fixes[dedupe]); }
        if (q.length > 3) { const t=q.slice(0,-1); set.add(t); if (fixes[t]) set.add(fixes[t]); }
        const normalized = this._normalizeQuery(q);
        if (normalized !== q) set.add(normalized);
        const words = q.split(" ");
        const withoutColor = words.filter(w => !this._colorMap[w]).join(" ").trim();
        if (withoutColor && withoutColor !== q && withoutColor.length > 1) set.add(withoutColor);
        return [...set].filter(v => v.length >= 2).slice(0,6);
      },

      _MODIFIER_WORDS: ["vert","rouge","bleu","noir","rose","jaune","orange","dore","argent","violet","blanc","gris","bronze","titane","tungstene","laiton"],

      _extractModifiers(query) {
        const qn = this._normalizeQuery(query);
        const words = qn.split(" ").filter(Boolean);
        return words.filter(w => this._MODIFIER_WORDS.includes(w) || /^\d{2}g$/.test(w));
      },

      _TYPE_COLLECTIONS: {
        "Steel Tip": "flechettes-acier-steeltip",
        "Soft Tip": "flechettes-plastique-softtip",
        "Ailettes": "ailettes-flechettes",
        "Tiges": "tiges-shafts",
        "Fusion Ailettes Tiges": "fusion-ailettes-tiges",
        "Pointes acier": "pointes-acier-flechettes",
        "Pointes plastiques": "pointes-plastique-flechettes",
        "Etuis": "etuis-rangement-flechettes",
        "Cibles Sisal": "cibles-sisal",
        "Cibles électroniques": "cibles-electroniques",
        "Surround": "surrounds-protections-murales",
        "Eclairage": "eclairage-cible-flechettes",
        "Tapis": "tapis-flechettes-oches",
        "Entretien": "entretien-maintenance-flechettes",
        "Cabinet": "cabinet",
      },

      _COLOR_TAGS: ["noir","blanc","rouge","bleu","vert","jaune","orange","rose","violet","gris","dore","argent","bronze"],

      _normalizeProduct(p, rankIndex) {
        const variants = p.variants || [];
        const v0 = variants[0] || {};
        const prices = variants.map(v => parseFloat(v.price)).filter(n => !isNaN(n));
        const comparePrices = variants.map(v => parseFloat(v.compare_at_price)).filter(n => !isNaN(n));
        const tags = p.tags || [];
        return {
          handle: p.handle,
          title: p.title,
          vendor: p.vendor,
          type: (p.product_type || "").replace(/\s+/g, " ").trim(),
          tags: tags,
          url: "/products/" + p.handle,
          price: (prices.length ? Math.min(...prices) : parseFloat(v0.price) || 0).toString(),
          compare_at_price_min: (comparePrices.length ? Math.min(...comparePrices) : parseFloat(v0.compare_at_price) || 0).toString(),
          featured_image: (p.images && p.images[0]) ? { url: p.images[0].src } : null,
          variants: variants.map(v => ({ id: v.id })),
          available: variants.length ? variants.some(v => v.available !== false) : true,
          colors: tags.map(t => this._norm(t)).filter(t => this._COLOR_TAGS.includes(t)),
          // Position dans la collection triée manuellement par le Worker de ranking business
          // (stock, marge, ventes, reco_priority, joueur, marque...). Plus petit = mieux classé.
          rankIndex: typeof rankIndex === "number" ? rankIndex : 9999,
        };
      },

      async _fetchJsonPages(baseUrl, fields) {
        const fetchPage = async (page) => {
          try {
            const sep = baseUrl.includes("?") ? "&" : "?";
            const r = await fetch(baseUrl + sep + "limit=250&page=" + page + (fields ? "&fields=" + fields : ""));
            const d = await r.json();
            return d.products || [];
          } catch(e) { return []; }
        };
        let all = [];
        let page = 1;
        const MAX_PAGES = 4;
        while (page <= MAX_PAGES) {
          const batch = await fetchPage(page);
          all = all.concat(batch);
          if (batch.length < 250) break;
          page++;
        }
        return all;
      },

      async _loadCatalog() {
        const cacheKey = "pb_catalog_v4";
        try {
          const cached = sessionStorage.getItem(cacheKey);
          if (cached) {
            const parsed = JSON.parse(cached);
            if (Date.now() - parsed.ts < 60 * 60 * 1000 && Array.isArray(parsed.products)) { return parsed.products; }
          }
        } catch(e) {}

        const fields = "id,handle,title,vendor,product_type,tags,variants,images";
        const seen = new Set();
        let all = [];

        // 1) Collections typées, triées manuellement par le Worker de ranking business
        //    → on garde leur ordre tel quel (rankIndex = position dans la collection)
        const handles = Object.values(this._TYPE_COLLECTIONS);
        const collectionResults = await Promise.all(
          handles.map(h => this._fetchJsonPages("/collections/" + h + "/products.json?sort_by=manual", fields))
        );
        collectionResults.forEach(list => {
          list.forEach((p, idx) => {
            if (seen.has(p.handle)) return;
            seen.add(p.handle);
            all.push(this._normalizeProduct(p, idx));
          });
        });

        // 2) Filet de sécurité : catalogue complet, pour les produits absents des collections
        //    ci-dessus (type manquant/mal renseigné) ou pour les recherches par marque/modèle
        //    qui traversent plusieurs types. Pas de rankIndex fiable ici (classés en dernier).
        const fullCatalog = await this._fetchJsonPages("/products.json", fields);
        fullCatalog.forEach(p => {
          if (seen.has(p.handle)) return;
          seen.add(p.handle);
          all.push(this._normalizeProduct(p));
        });

        try { sessionStorage.setItem(cacheKey, JSON.stringify({ ts: Date.now(), products: all })); } catch(e) {}
        return all;
      },

      _hasWordPrefix(text, word) {
        return (text || "").split(" ").some(tok => tok.length > 0 && tok.startsWith(word));
      },

      _fuzzyStrict(query) {
        const q = this._norm(query);
        const set = new Set([query, q]);
        const fixes = {"fl":"flechette","fle":"flechette","flec":"flechette","flech":"flechette","fleche":"flechette","flechett":"flechette","flechete":"flechette","flechetes":"flechette","flechettes":"flechette","flchette":"flechette","flchettes":"flechette","flechtte":"flechette","dart":"flechette","darts":"flechette","ci":"cible","cib":"cible","cibl":"cible","cibles":"cible","dartboard":"cible","board":"cible","sisal":"cible sisal","armoire":"cabinet","armoires":"cabinet","ai":"ailette","ail":"ailette","aile":"ailette","ailtte":"ailette","ailetes":"ailette","ailettes":"ailette","fli":"flight","fligh":"flight","flights":"flight","ti":"tige","tig":"tige","tge":"tige","tiges":"tige","sha":"shaft","shaf":"shaft","shafts":"shaft","poi":"pointe","poin":"pointe","point":"pointe","pointes":"pointe","etu":"etui","etuit":"etui","etuis":"etui","sacoche":"etui","trousse":"etui","tap":"tapis","tapi":"tapis","sur":"surround","surr":"surround","anneau":"surround","bul":"bulls","bull":"bulls","buls":"bulls","unicor":"unicorn","mision":"mission","missoin":"mission","harows":"harrows","harrow":"harrows","designas":"designa","dezigna":"designa","granboar":"granboard","granbord":"granboard","winmaux":"winmau","winmo":"winmau"};
        const fixed = fixes[q]; if (fixed) set.add(fixed);
        const dedupe = q.replace(/(.)\1+/g,"$1");
        if (dedupe !== q) { set.add(dedupe); if (fixes[dedupe]) set.add(fixes[dedupe]); }
        const normalized = this._normalizeQuery(q);
        if (normalized !== q) set.add(normalized);
        const words = q.split(" ");
        const withoutColor = words.filter(w => !this._colorMap[w]).join(" ").trim();
        if (withoutColor && withoutColor !== q && withoutColor.length > 1) set.add(withoutColor);
        return [...set].filter(v => v.length >= 2);
      },

      _matchesQuery(p, query) {
        const t = this._norm(p.title || "");
        const v = this._norm(p.vendor || "");
        const tags = (p.tags||[]).map(tag => this._norm(tag)).join(" ");
        const hay = t + " " + v + " " + tags;
        const variants = this._fuzzyStrict(query);
        return variants.some(variant => {
          const words = variant.split(" ").filter(Boolean);
          return words.length > 0 && words.every(w => this._hasWordPrefix(hay, w));
        });
      },

      async _fetchProducts(query) {
        const catalog = await this._loadCatalog();
        const cat = this._cat(query);
        const types = cat ? this._CAT[cat] : null;
        const modifiers = this._extractModifiers(query);

        let candidates;
        if (types) {
          candidates = catalog.filter(p => types.includes(p.type));
          if (candidates.length === 0) { candidates = catalog.filter(p => this._matchesQuery(p, query)); }
        } else {
          candidates = catalog.filter(p => this._matchesQuery(p, query));
        }

        if (modifiers.length) {
          const allMatch = candidates.filter(p => { const t = this._norm(p.title||""); return modifiers.every(m => this._hasWordPrefix(t, m)); });
          if (allMatch.length > 0) { candidates = allMatch; }
          else {
            const anyMatch = candidates.filter(p => { const t = this._norm(p.title||""); return modifiers.some(m => this._hasWordPrefix(t, m)); });
            if (anyMatch.length > 0) candidates = anyMatch;
          }
        }

        return candidates;
      },

      _score(p, query) {
        const q = this._norm(query);
        const t = this._norm(p.title||"");
        const v = this._norm(p.vendor||"");
        let sc = 0;
        if (t.startsWith(q)) sc += 20;
        else if (t.includes(q)) sc += 10;
        else if (t.split(" ").some(w => w.startsWith(q))) sc += 5;
        if (v === q || v.includes(q)) sc += 8;
        const modifiers = this._extractModifiers(query);
        modifiers.forEach(m => { if (this._hasWordPrefix(t, m)) sc += 15; });
        if (t.includes("22g")||t.includes("23g")||t.includes("24g")) sc += 2;
        return sc;
      },

      _typePriority(type) {
        const P = { "Steel Tip":1,"Soft Tip":1,"Cibles Sisal":2,"Cibles électroniques":2,"Cabinet":2,"Tiges":3,"Ailettes":3,"Fusion Ailettes Tiges":3,"Pointes acier":4,"Pointes plastiques":4,"Surround":5,"Eclairage":5,"Tapis":5,"Pack":5,"Etuis":9,"Entretien":9,"Accessoires":9 };
        return P[type] || 6;
      },

      async _runSearch() {
        this.loading = true;
        const cat = this._cat(this.query);
        const types = cat ? this._CAT[cat] : null;
        const raw = await this._fetchProducts(this.query);
        const scored = raw.map((product, index) => ({ product, index, score: this._score(product, this.query) }));
        scored.sort((a, b) => {
          const typeDiff = this._typePriority(a.product.type) - this._typePriority(b.product.type);
          if (typeDiff) return typeDiff;
          if (types) {
            // Recherche de catégorie : l'ordre business (ventes, marge, stock, reco_priority...)
            // déjà calculé par le Worker prime sur notre score texte, souvent bruité
            // (beaucoup de titres commencent tous par "Fléchettes ...").
            return (a.product.rankIndex - b.product.rankIndex) || (b.score - a.score) || (a.index - b.index);
          }
          // Recherche par marque/modèle précis : la pertinence texte prime, rankIndex départage.
          return (b.score - a.score) || (a.product.rankIndex - b.product.rankIndex) || (a.index - b.index);
        });
        this.products = scored.map(item => item.product);
        this.visibleCount = this.pageSize;
        this.loading = false;
      },

      get facetVendors() {
        const counts = {};
        this.products.forEach(p => { if (p.vendor) counts[p.vendor] = (counts[p.vendor]||0) + 1; });
        return Object.keys(counts).sort((a,b) => a.localeCompare(b)).map(v => ({ value: v, count: counts[v] }));
      },
      get facetTypes() {
        const counts = {};
        this.products.forEach(p => { if (p.type) counts[p.type] = (counts[p.type]||0) + 1; });
        return Object.keys(counts).sort((a,b) => a.localeCompare(b)).map(t => ({ value: t, count: counts[t] }));
      },
      get facetColors() {
        const counts = {};
        this.products.forEach(p => (p.colors||[]).forEach(c => { counts[c] = (counts[c]||0) + 1; }));
        return Object.keys(counts).sort((a,b) => a.localeCompare(b)).map(c => ({ value: c, count: counts[c] }));
      },
      get hasActiveFilters() {
        const f = this.filters;
        return f.vendors.length > 0 || f.types.length > 0 || f.colors.length > 0 || f.inStock || f.minPrice !== "" || f.maxPrice !== "";
      },

      toggleFilter(group, value) {
        const list = this.filters[group];
        const i = list.indexOf(value);
        if (i === -1) list.push(value); else list.splice(i, 1);
        this.visibleCount = this.pageSize;
      },
      toggleInStock() {
        this.filters.inStock = !this.filters.inStock;
        this.visibleCount = this.pageSize;
      },
      onPriceChange() { this.visibleCount = this.pageSize; },
      onSortChange() { this.visibleCount = this.pageSize; },
      resetFilters() {
        this.filters = { vendors: [], types: [], colors: [], inStock: false, minPrice: "", maxPrice: "" };
        this.visibleCount = this.pageSize;
      },

      get filteredProducts() {
        const f = this.filters;
        const min = parseFloat(f.minPrice);
        const max = parseFloat(f.maxPrice);
        let list = this.products.filter(p => {
          if (f.vendors.length && !f.vendors.includes(p.vendor)) return false;
          if (f.types.length && !f.types.includes(p.type)) return false;
          if (f.colors.length && !(p.colors||[]).some(c => f.colors.includes(c))) return false;
          if (f.inStock && !p.available) return false;
          const price = parseFloat(p.price) || 0;
          if (!isNaN(min) && price < min) return false;
          if (!isNaN(max) && price > max) return false;
          return true;
        });
        if (this.sortBy === "price_asc") { list = list.slice().sort((a,b) => (parseFloat(a.price)||0) - (parseFloat(b.price)||0)); }
        else if (this.sortBy === "price_desc") { list = list.slice().sort((a,b) => (parseFloat(b.price)||0) - (parseFloat(a.price)||0)); }
        return list;
      },

      get visibleProducts() { return this.filteredProducts.slice(0, this.visibleCount); },

      loadMore() { this.visibleCount += this.pageSize; },

      cardHTML(p) {
        const pr = parseFloat(p.price||"0");
        const price = pr > 0 ? pr.toFixed(2).replace(".",",")+"\u00a0€" : "";
        const cp = parseFloat(p.compare_at_price_min||"0");
        const was = cp > pr ? cp.toFixed(2).replace(".",",")+"\u00a0€" : null;
        const img = (p.featured_image?.url||p.image) ? (p.featured_image?.url||p.image)+"&width=400" : null;
        const tags = (p.tags||[]).map(t=>(t||"").toLowerCase());
        const steel = p.type==="Steel Tip"||tags.some(t=>t.includes("steel tip"));
        const soft = p.type==="Soft Tip"||tags.some(t=>t.includes("soft tip"));
        const url = p.url||"/products/"+p.handle;
        const vid = p.variants?.[0]?.id||0;
        return `<div class="pb-c"><a href="${url}" class="pb-c-link"><div class="pb-c-img-wrap">${img?`<img src="${img}" alt="${(p.title||"").replace(/"/g,"&quot;")}" loading="lazy" class="pb-c-img">`:`<div class="pb-c-img-ph"></div>`}<div class="pb-c-badges">${steel?`<span class="pb-b pb-b-steel">⚙ Steel</span>`:""}${soft?`<span class="pb-b pb-b-soft">● Soft</span>`:""}</div>${vid?`<div class="pb-c-atc"><button class="pb-c-atc-btn" onclick="event.preventDefault();event.stopPropagation();var f=document.createElement('form');f.method='POST';f.action='/cart/add';var i=document.createElement('input');i.type='hidden';i.name='id';i.value='${vid}';f.appendChild(i);document.body.appendChild(f);f.submit();" title="Ajouter au panier"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg></button></div>`:""}</div><div class="pb-c-body">${p.vendor?`<p class="pb-c-vendor">${p.vendor}</p>`:""}<h3 class="pb-c-title">${p.title||""}</h3><div class="pb-c-price-wrap"><span class="pb-c-price${was?" pb-c-price-sale":""}">${price}</span>${was?`<span class="pb-c-price-was">${was}</span>`:""}</div></div></a></div>`;
      },
    }));

    Alpine.data("xFreeShipping", (sectionId) => ({
      init() {
        document.addEventListener(`${CART_EVENT.cartUpdate}`, (e) => {
          fetch(`${window.location.pathname}?section_id=${sectionId}`).then((response) => response.text()).then((response) => {
            const html = new DOMParser().parseFromString(response, "text/html");
            const newContent = html.getElementById("announcement-free-shipping");
            this.$el.innerHTML = newContent.innerHTML;
          });
        });
      },
    }));

    Alpine.data("xCollapsibleTab", (initIsOpen) => ({
      isOpenCollapsible: initIsOpen,
      init() {
        if (!initIsOpen) { let collapsibleContentEle = this.$el.querySelector(`.collapsible-tab__content`); if (collapsibleContentEle) { collapsibleContentEle.classList.remove(`hidden`); } }
      },
      handleToggleTab: function () { this.isOpenCollapsible = !this.isOpenCollapsible; }
    }));

    Alpine.data('xMediaModel', () => ({
      MAX_RETRIES_WAIT_SCROLL_END: 50,
      loaded: false,
      handleInit() {
        this.loaded = true;
        window.Shopify.loadFeatures([{ name: 'shopify-xr', version: '1.0', onLoad: this.__setUpShopifyXR.bind(this) }]);
      },
      handleLoadModel() {
        let container = this.$el.parentNode;
        const content = document.createElement('div');
        content.appendChild(container.querySelector('template').content.firstElementChild.cloneNode(true));
        this.$el.classList.add('hidden');
        container.appendChild(content.querySelector('model-viewer'));
        this.__loadViewerUI();
      },
      handlePauseViewer() { if (this.$el.modelViewerUI) this.$el.modelViewerUI.pause(); },
      __setUpShopifyXR() {
        const setup = () => { document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => { window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent)); modelJSON.remove(); }); window.ShopifyXR.setupXRElements(); };
        if (!window.ShopifyXR) { document.addEventListener('shopify_xr_initialized', () => { setup(); }); return; }
        setup();
      },
      __loadViewerUI() { window.Shopify.loadFeatures([{ name: 'model-viewer-ui', version: '1.0', onLoad: this.__setUpViewerUI.bind(this) }]); },
      __setUpViewerUI(errors) { if (errors) return; this.$el.parentNode.modelViewerUI = new Shopify.ModelViewerUI(this.$el.parentNode.querySelector('model-viewer')); },
      waitScrollEndedOnDesktop(callback) {
        let count = 0;
        const isMobile = window.innerWidth < MIN_DEVICE_WIDTH.tablet;
        const galleryWrapperDataset = this.$el.closest('.media-gallery__wrapper')?.dataset;
        const intervalId = setInterval(() => {
          if (isMobile || galleryWrapperDataset?.isScrollingOnDesktop != 'true' || count >= this.MAX_RETRIES_WAIT_SCROLL_END) {
            if (galleryWrapperDataset) { galleryWrapperDataset.isScrollingOnDesktop = 'false'; }
            clearInterval(intervalId); callback(); return;
          }
          count++;
        }, TIMEOUT.scrollIdle);
      },
      initModelInSlideEffect() {
        this.waitScrollEndedOnDesktop(() => {
          const mediaitem = this.$el.closest('.media-gallery__media-item');
          if (this.loaded || !mediaitem.classList.contains('is-active-in-two-columns')) return;
          this.handleInit(); this.handleLoadModel();
        });
        document.addEventListener(`${PRODUCT_MEDIA_EVENT.show_model}-${this.$el.dataset.mediaId}`, (event) => {
          if (this.loaded) return;
          if (window.innerWidth >= MIN_DEVICE_WIDTH.tablet) { this.waitScrollEndedOnDesktop(() => { if (this.loaded) return; this.handleInit(); this.handleLoadModel(); }); }
          else { this.handleInit(); this.handleLoadModel(); }
        });
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xCustomerEvent', {
      fire(eventName, el, data) {
        if (Shopify.designMode) return;
        const formatedData = data ? data : xParseJSON(el.dataset.customEvent);
        Shopify.analytics.publish(eventName, formatedData);
      }
    });

    Alpine.store("xEstimateDelivery", {
      hour: 0, minute: 0, notification: '',
      countdownCutOffTime(cutOffTime, hrsText, minusText) {
        if (this.notification != '') return;
        const now = new Date();
        const currentHour = now.getHours(); const currentMinute = now.getMinutes();
        const cutOffHour = cutOffTime.length >= 3 ? parseInt(cutOffTime.slice(0, -2), 10) : 0;
        const cutOffMinute = cutOffTime.length >= 3 ? parseInt(cutOffTime.slice(-2), 10) : 0;
        const current = new Date(now.getFullYear(), now.getMonth(), now.getDate(), currentHour, currentMinute);
        const cutOff = new Date(now.getFullYear(), now.getMonth(), now.getDate(), cutOffHour, cutOffMinute);
        if (current >= cutOff) { cutOff.setDate(cutOff.getDate() + 1); }
        const diffMs = cutOff - current;
        this.hour = Math.floor(diffMs / 1000 / 60 / 60);
        this.minute = Math.floor((diffMs / 1000 / 60) % 60);
        return this.hour > 0 ? this.notification = this.hour + ' ' + hrsText + ' ' + this.minute + ' ' + minusText : this.notification = this.minute + ' ' + minusText;
      },
      updateWidthAndPositionTooltipPopup(el, estimateDeliveryEl, isDrawerCart) {
        if (!isDrawerCart || document.getElementById('CartDrawer')?.isOpen) {
          const tooltipPopupEl = el.querySelector('.tooltip-popup');
          let tooltipWidth = estimateDeliveryEl.offsetWidth * 2 / 3;
          const rectEstimateDelivery = estimateDeliveryEl.getBoundingClientRect();
          const rectTooltip = el.getBoundingClientRect();
          tooltipPopupEl.style.width = tooltipWidth + 'px';
          const originalStyle = tooltipPopupEl.getAttribute("style") || "";
          tooltipPopupEl.style.cssText += `position: absolute !important;visibility: hidden !important;display: block !important;`;
          requestAnimationFrame(() => {
            const newTooltipWidth = tooltipPopupEl.querySelector('.flash-message').offsetWidth;
            tooltipPopupEl.setAttribute("style", originalStyle);
            if (newTooltipWidth < tooltipWidth) { tooltipPopupEl.style.width = `${newTooltipWidth}px`; tooltipWidth = newTooltipWidth; }
            const minTooltipContentOffset = 4, minTooltipMarginEDT = 10;
            if (window.Maximize.rtl) {
              const innerWidth = window.innerWidth;
              if ((innerWidth - rectTooltip.right) - (innerWidth - rectEstimateDelivery.right) > (tooltipWidth - minTooltipContentOffset)) { tooltipPopupEl.style.right = ''; tooltipPopupEl.style.left = `-${minTooltipContentOffset}px`; }
              else { tooltipPopupEl.style.right = `-${(innerWidth - rectTooltip.right) - (innerWidth - rectEstimateDelivery.right) - minTooltipMarginEDT}px`; tooltipPopupEl.style.left = ''; }
            } else {
              if (rectTooltip.left - rectEstimateDelivery.left > (tooltipWidth - minTooltipContentOffset)) { tooltipPopupEl.style.left = ''; tooltipPopupEl.style.right = `-${minTooltipContentOffset}px`; }
              else { tooltipPopupEl.style.left = `-${rectTooltip.left - rectEstimateDelivery.left - minTooltipMarginEDT}px`; tooltipPopupEl.style.right = ''; }
            }
          });
        }
      },
      setupTooltipPopup(el, isDrawerCart) {
        const estimateDeliveryEl = el.closest('.x-estimate-delivery');
        const debounce = (callback, delay) => { let timer; return function () { clearTimeout(timer); timer = setTimeout(callback, delay); }; };
        this.updateWidthAndPositionTooltipPopup(el, estimateDeliveryEl, isDrawerCart);
        window.addEventListener('resize', debounce(() => { this.updateWidthAndPositionTooltipPopup(el, estimateDeliveryEl, isDrawerCart); }, 300));
      }
    });
  });
});

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.store('xResizeHandler', {
      callbacks: [], triggerResize: null,
      debounce(func, delay) { let timer; return function (...args) { clearTimeout(timer); timer = setTimeout(() => func.apply(this, args), delay); }; },
      register(callback, allowDuplicateFuntc, ...params) {
        if (allowDuplicateFuntc) { this.callbacks.push({callback, params}); }
        else if (!this.callbacks.find(item => item.callback === callback)) { this.callbacks.push({callback, params}); }
      },
      unregister(callback) { this.callbacks = this.callbacks.filter(item => item.callback !== callback); },
      init() {
        this.triggerResize = this.debounce(() => { this.callbacks.forEach(({callback, params}) => { callback(...params); }); }, 50);
        window.addEventListener("resize", this.triggerResize);
      }
    });
  });
});

function maximizeParseJSON(jsonString) {
  jsonString = String.raw`${jsonString}`;
  jsonString = jsonString.replaceAll("\\", "\\\\").replaceAll('\\"', '"');
  return JSON.parse(jsonString);
}

requestAnimationFrame(() => {
  document.addEventListener('alpine:init', () => {
    Alpine.data('xProductDrawer', () => ({
      isShowDrawer: false,
      openDrawer(idBlockDrawer) { this.isShowDrawer = true; Alpine.store('xMaximizeDrawer').handleOpen(idBlockDrawer); },
      closeDrawer(closeQuickView = false) {
        Alpine.store('xFocusElement').removeTrapFocus();
        this.isShowDrawer = false;
        let closeAllDrawer = true;
        const isShowQuickView = Alpine.store('xQuickView') && Alpine.store('xQuickView').show;
        if (isShowQuickView && (!closeQuickView || window.innerWidth < MIN_DEVICE_WIDTH.tablet)) { closeAllDrawer = false; }
        Alpine.store('xMaximizeDrawer').handleClose(closeAllDrawer);
        if (isShowQuickView && closeQuickView && window.innerWidth >= MIN_DEVICE_WIDTH.tablet) { Alpine.store('xQuickView').close(); }
      }
    }));
  });
});

requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xStoreMap", {
      currentStoreSelected: JSON.parse(localStorage.getItem("currentStoreSelected"))?.selectedStore || "",
      getStore() { if (this.currentStoreSelected) { return this.currentStoreSelected.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;"); } },
      getStoreText() { if (this.currentStoreSelected !== "") { return this.currentStoreSelected; } },
      checkAvailability(storeAvailabilities) { let store = this.getStore(); if (storeAvailabilities) { return storeAvailabilities[store]; } },
      dispatchEventOpenPopup() { document.dispatchEvent(new CustomEvent(`${STORE_MAP_EVENT.openPopup}`)); }
    });
  });
});

function formatWithDelimiters(number, precision, thousands, decimal) {
  precision = defaultOption(precision, 2); thousands = defaultOption(thousands, ','); decimal = defaultOption(decimal, '.');
  if (isNaN(number) || number == null) { return 0; }
  number = (number / 100.0).toFixed(precision);
  let parts = number.split('.'), dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands), cents = parts[1] ? (decimal + parts[1]) : '';
  return dollars + cents;
}

function defaultOption(opt, def) { return (typeof opt == 'undefined' ? def : opt); }

function formatMoney(amount, formatString) {
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let value;
  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount': value = formatWithDelimiters(amount, 2); break;
    case 'amount_no_decimals': value = formatWithDelimiters(amount, 0); break;
    case 'amount_with_comma_separator': value = formatWithDelimiters(amount, 2, '.', ','); break;
    case 'amount_no_decimals_with_comma_separator': value = formatWithDelimiters(amount, 0, '.', ','); break;
  }
  return formatString.replace(placeholderRegex, value);
}

function debounce(func, wait) { let timeout; return function (...args) { clearTimeout(timeout); timeout = setTimeout(() => func.apply(this, args), wait); }; }

function validateEmail(email) {
  const VALID_REGEX_EMAIL = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+$/;
  if (email === '') { return {'isError': true, 'isRequired': true}; }
  else if (!email.match(VALID_REGEX_EMAIL)) { return {'isError': true, 'isInvalid': true}; }
  else { return {'isError': false}; }
}

function getValueCssVariable(varName, element = document.documentElement, shouldConvertToFloat = false) {
  const value = getComputedStyle(element).getPropertyValue(varName).trim();
  if (!shouldConvertToFloat) return value;
  if (!value) return 0;
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const elementFontSize = parseFloat(getComputedStyle(element).fontSize);
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) return 0;
  if (value.endsWith('ms')) return numericValue;
  if (value.endsWith('s')) return numericValue * MS_PER_SECOND;
  if (value.endsWith('rem')) return numericValue * rootFontSize;
  if (value.endsWith('em')) return numericValue * elementFontSize;
  return numericValue;
}

// =============================================================================
// Highlight animation & fade-on-intersect observer
// =============================================================================
(function setupHighlightObserver() {
  let SELECTOR = '[data-highlight-class],[data-fade-on-intersect]';
  let observer = new IntersectionObserver(function(entries, obs) {
    entries.forEach(function(entry) {
      if (!entry.isIntersecting) return;
      let el = entry.target;
      obs.unobserve(el);
      if (el.dataset.highlightClass) {
        let delay = parseInt(el.dataset.highlightDelay, 10) || 0;
        if (delay) { setTimeout(function() { el.classList.add(el.dataset.highlightClass); }, delay); }
        else { el.classList.add(el.dataset.highlightClass); }
      }
      if ('fadeOnIntersect' in el.dataset) { el.classList.add('is-visible'); }
    });
  }, { rootMargin: '0px 0px -20px 0px' });

  function applyInViewport(root) {
    let vh = window.innerHeight;
    let toShow = [], toObserve = [];
    (root || document).querySelectorAll(SELECTOR).forEach(function(el) {
      if (el.dataset.fadeObserved) return;
      let rect = el.getBoundingClientRect();
      if (rect.top < vh && rect.bottom > 0) { toShow.push(el); } else { toObserve.push(el); }
    });
    toShow.forEach(function(el) { el.dataset.fadeObserved = '1'; el.classList.add('is-visible', 'transition-none'); });
    toObserve.forEach(function(el) { el.dataset.fadeObserved = '1'; observer.observe(el); });
  }

  function observeAll(root) {
    (root || document).querySelectorAll(SELECTOR).forEach(function(el) {
      if (!el.dataset.fadeObserved) { el.dataset.fadeObserved = '1'; observer.observe(el); }
    });
  }

  applyInViewport();

  document.addEventListener('alpine:initialized', function() {
    observeAll();
    if (window.xCartHelper) window.xCartHelper.handleSharedCart();
    requestAnimationFrame(function() { let header = document.querySelector('.opacity-main-header'); if (header) header.classList.remove('opacity-main-header'); });
  });

  new MutationObserver(function(mutations) {
    for (let i = 0; i < mutations.length; i++) {
      let added = mutations[i].addedNodes;
      for (let j = 0; j < added.length; j++) {
        let node = added[j];
        if (node.nodeType !== 1) continue;
        if (node.matches(SELECTOR) && !node.dataset.fadeObserved) { node.dataset.fadeObserved = '1'; observer.observe(node); }
        if (node.firstElementChild) { node.querySelectorAll(SELECTOR).forEach(function(el) { if (!el.dataset.fadeObserved) { el.dataset.fadeObserved = '1'; observer.observe(el); } }); }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  window._fadeObserver = { observe: observeAll };
})();

// === Pickup Message ===
(function setupPickupMessage() {
  if (!document.querySelector('.pickup-message__wrapper')) return;
  function parsePipeList(str) { return (str || '').split('|||').map(function(s) { return s.trim(); }).filter(Boolean); }
  function parseAvailMap(str) { let map = {}; parsePipeList(str).forEach(function(entry) { let idx = entry.lastIndexOf('::'); if (idx === -1) return; map[entry.slice(0, idx)] = entry.slice(idx + 2) === 'true'; }); return map; }
  function applyStore(storeName) {
    document.querySelectorAll('.pickup-message__wrapper[data-pickup-locs]').forEach(function(el) {
      if (!storeName) { el.style.display = 'none'; return; }
      let locs = parsePipeList(el.dataset.pickupLocs);
      if (!locs.includes(storeName)) { el.style.display = 'none'; return; }
      let avail = parseAvailMap(el.dataset.pickupAvail);
      let isAvail = avail[storeName] === true;
      el.style.display = '';
      el.querySelector('.pickup-msg-avail').style.display = isAvail ? '' : 'none';
      el.querySelector('.pickup-msg-unavail').style.display = isAvail ? 'none' : '';
      el.querySelectorAll('.pickup-store-name').forEach(function(s) { s.textContent = storeName; });
    });
  }
  let saved = JSON.parse(localStorage.getItem('currentStoreSelected') || 'null');
  if (saved && saved.selectedStore) applyStore(saved.selectedStore);
  document.addEventListener('maximize:store-changed', function(e) { applyStore(e.detail.store || ''); });
})();

/* ── xParallax (ancien theme.js uniquement) ── */
requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.data("xParallax", () => ({
      debounce(func, wait) {
        let timeout;
        return function () {
          let context = this, args = arguments;
          let later = function () { timeout = null; func.apply(context, args); };
          clearTimeout(timeout); timeout = setTimeout(later, wait);
        };
      },
      load(disable) {
        if (disable) return;
        if ("IntersectionObserver" in window && "IntersectionObserverEntry" in window) {
          const observer = new IntersectionObserver(handleIntersect, { root: null, rootMargin: "0px 0px", threshold: 0 });
          let el;
          function handleIntersect(entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) { el = entry.target; window.addEventListener("scroll", parallax, {passive: true, capture: false}); }
              else { window.removeEventListener("scroll", parallax, {passive: true, capture: false}); }
            });
          }
          observer.observe(this.$el);
          const parallax = this.debounce(function () {
            const rect = el.getBoundingClientRect();
            let speed = (window.innerHeight / el.parentElement.offsetHeight) * 20;
            let shiftDistance = (rect.top - window.innerHeight) / speed;
            let maxShiftDistance = el.parentElement.offsetHeight / 11;
            if (shiftDistance < -maxShiftDistance || shiftDistance > maxShiftDistance) { shiftDistance = -maxShiftDistance; }
            el.style.transform = "translate3d(0, " + shiftDistance + "px, 0)";
          }, 10);
        }
      },
    }));
  });
});

/* ── xProductComparison (ancien theme.js uniquement) ── */
requestAnimationFrame(() => {
  document.addEventListener("alpine:init", () => {
    Alpine.store("xProductComparison", {
      isShowWidget: false, isShowDrawer: false, isShowPopup: false,
      listComparisonProducts: [], listComparisonProductsPopUp: [], cacheResults: [],
      isClickAddToCompare: false, maximumProductCompare: 0, loadingOpenDrawer: false, loadingFetchDataPopup: false,
      array_variant_options: [], array_product_metafields: [], sectionId: '',
      arrow_prev: null, arrow_next: null, table_container: null, scrollPosition: 0, hasSection: false,
      init(sectionId) {
        this.listComparisonProducts = JSON.parse(window.localStorage.getItem("maximize-product-comparison") || "[]");
        const productComparisonOverlayEle = document.querySelector('#productComparisonOverlay');
        this.sectionId = sectionId;
        if (productComparisonOverlayEle) { this.maximumProductCompare = parseInt(productComparisonOverlayEle.dataset.maximumProductCompare); }
      },
      updateArrowStatus() {
        if (this.arrow_prev && this.arrow_next) {
          const isStart = Math.abs(this.scrollPosition) <= 0;
          const isEnd = Math.abs(Math.abs(this.scrollPosition) - (this.table_container.scrollWidth - this.table_container.clientWidth)) <= 2;
          this.arrow_prev.classList.toggle('product-compare__arrow-active', !isStart);
          this.arrow_prev.classList.toggle('product-compare__arrow-disable', isStart);
          this.arrow_next.classList.toggle('product-compare__arrow-active', !isEnd);
          this.arrow_next.classList.toggle('product-compare__arrow-disable', isEnd);
        }
      },
      roundIndex(number, isRoudDown = true) {
        let rounded = Math.round(number);
        return Math.abs(number - rounded) <= 0.02 ? rounded : (isRoudDown ? Math.floor(number) : Math.ceil(number));
      },
      slide(next = true) {
        if (next && this.arrow_next.classList.contains('product-compare__arrow-active') || !next && this.arrow_prev.classList.contains('product-compare__arrow-active')) {
          const itemWidth = this.table_container.querySelector('.product-comparison-grid-item:not(.product-comparison-grid-title)').getBoundingClientRect().width;
          const currentItemIndex = this.roundIndex(Math.abs(this.scrollPosition / itemWidth), true);
          if (next) {
            this.scrollPosition = (currentItemIndex + 1) * itemWidth;
            if (Math.abs(Math.abs(this.scrollPosition) - (this.table_container.scrollWidth - this.table_container.clientWidth)) <= 2) { this.scrollPosition = this.table_container.scrollWidth - this.table_container.clientWidth; }
          } else {
            this.scrollPosition = currentItemIndex == this.roundIndex(Math.abs(this.scrollPosition / itemWidth), false) ? (currentItemIndex - 1) * itemWidth : currentItemIndex * itemWidth;
            if (Math.abs(this.scrollPosition) < 0) { this.scrollPosition = 0; }
          }
          this.scrollPosition *= window.Maximize.rtl ? -1 : 1;
          this.table_container.scrollTo({ left: this.scrollPosition, behavior: 'smooth' });
          this.updateArrowStatus();
        }
      },
      updateCSSVariables(sectionId) {
        if (sectionId && !this.sectionId) { this.sectionId = sectionId; }
        const table = document.querySelector(`.product-comparison-table--${this.sectionId}`);
        table?.style.setProperty('--product-comparison-item-in-table', window.innerWidth >= MIN_DEVICE_WIDTH.desktop ? this.listComparisonProducts.length + 1 : this.listComparisonProducts.length);
      },
      setData(list_variant_options, list_product_metafields) {
        this.hasSection = true;
        this.array_variant_options = list_variant_options.split('|||').filter(item => item != null && item != '');
        this.array_product_metafields = list_product_metafields.split('|||').filter(item => item != null && item != '');
        fetch(Shopify.routes.root + 'cart/update', { method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'}, body: JSON.stringify({ 'attributes': { [CART_ATTRIBUTES.product_comparison_options]: this.array_variant_options.join('|||'), [CART_ATTRIBUTES.product_comparison_metafields]: this.array_product_metafields.join('|||') } }) });
      },
      addProductToCompare(productId, productHandle) {
        if ((this.listComparisonProducts.length >= this.maximumProductCompare && !this.isClickAddToCompare) || this.listComparisonProducts.some(item => item.productId === productId)) return;
        this.isClickAddToCompare = true;
        if (this.listComparisonProducts.length >= this.maximumProductCompare || this.listComparisonProducts.some(item => item.productId === productId)) { return; }
        this.isShowWidget = true;
        this.listComparisonProducts.push({ productId, productHandle });
        localStorage.setItem("maximize-product-comparison", JSON.stringify(this.listComparisonProducts));
        setTimeout(() => { this.isClickAddToCompare = false; this.showDrawer(); }, 200);
        this.updateCSSVariables();
      },
      removeProductFromCompare(productId, productHandle) {
        this.listComparisonProducts = this.listComparisonProducts.filter((item) => item.productId !== productId);
        localStorage.setItem("maximize-product-comparison", JSON.stringify(this.listComparisonProducts));
        if (this.isShowPopup) {
          const itemData = document.querySelectorAll(`.product-comparison-${productHandle}`);
          if (itemData && itemData.length > 0) {
            for (let i = 0; i < itemData.length; i++) {
              if (itemData[i]) {
                const item = itemData[i];
                item.classList.add('animation-fade-out');
                item.style.height = `${item.offsetHeight}px`;
                item.addEventListener('transitionend', (e) => { if (e.propertyName === 'width') { item.classList.add('hidden'); this.updateCSSVariables(); } });
              }
            }
          }
          if (this.listComparisonProducts.length == 0) { setTimeout(() => { this.closePopup(); }, 500); }
        } else {
          if (this.isShowDrawer) {
            const drawerItem = document.querySelector(`.product-comparison-overlay__item[data-product-id="${productId}"]`);
            if (drawerItem) { drawerItem.classList.add('animation-fade-out'); drawerItem.addEventListener('transitionend', () => { drawerItem.remove(); }); }
          }
          if (this.listComparisonProducts.length == 0) { this.hideDrawer(); }
          this.updateCSSVariables();
        }
      },
      clearAll() {
        if (this.isShowDrawer) {
          this.listComparisonProducts.forEach(item => {
            const drawerItem = document.querySelector(`.product-comparison-overlay__item[data-product-id="${item.productId}"]`);
            if (drawerItem) { drawerItem.classList.add('animation-fade-out'); drawerItem.addEventListener('transitionend', () => { drawerItem.remove(); }); }
          });
        }
        this.listComparisonProducts = [];
        localStorage.setItem("maximize-product-comparison", JSON.stringify(this.listComparisonProducts));
        this.hideDrawer();
      },
      handleDataDrawer(text) {
        const html = document.createElement('div');
        html.innerHTML = text;
        const drawerContainer = document.querySelector('#ProductComparisonDrawer__Main');
        const drawerContent = html.querySelector('.product-comparison__drawer-content');
        if (drawerContainer && drawerContent) { drawerContainer.innerHTML = drawerContent.innerHTML; }
        this.isShowDrawer = true;
        const overlayBodyEle = document.querySelector('.overlay-body');
        if (overlayBodyEle) { overlayBodyEle.classList.add('is-visible'); }
        document.body.classList.add("overflow-hidden");
      },
      showDrawer() {
        if (this.isShowDrawer) return;
        const productIdTerm = this.listComparisonProducts.map((item) => `id:${item.productId}`).join(' OR ');
        const url = `${window.Maximize.routes.search_url}?section_id=product-comparison-overlay&type=product&q=${productIdTerm}`;
        if (this.cacheResults[url]) { this.handleDataDrawer(this.cacheResults[url]); return; }
        this.loadingOpenDrawer = true;
        fetch(url).then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
          .then(text => { this.cacheResults[url] = text; this.handleDataDrawer(text); })
          .finally(() => { this.loadingOpenDrawer = false; });
      },
      hideDrawer() {
        if (!this.isShowDrawer) return;
        this.isShowDrawer = false;
        const overlayBodyEle = document.querySelector('.overlay-body');
        if (overlayBodyEle) { overlayBodyEle.classList.remove('is-visible'); }
        document.body.classList.remove("overflow-hidden");
      },
      showPopup() {
        const delay = parseInt(window.getComputedStyle(document.body).getPropertyValue('--drawer-transition-duration').replaceAll('ms', ''));
        setTimeout(() => {
          this.isShowPopup = true;
          this.listComparisonProductsPopUp = this.listComparisonProducts;
          const overlayBodyEle = document.querySelector('.overlay-body');
          if (overlayBodyEle) { overlayBodyEle.classList.add('is-visible'); }
          document.body.classList.add("overflow-hidden");
          this.handleDataPopUp();
        }, delay);
      },
      closePopup() {
        if (!this.isShowPopup) return;
        this.isShowPopup = false;
        document.body.classList.remove("overflow-hidden");
        Alpine.store('xFocusElement').removeTrapFocus();
        setTimeout(() => {
          this.listComparisonProductsPopUp.forEach(item => {
            document.querySelectorAll(`.product-comparison-${item.productHandle}.animation-fade-out.hidden`).forEach(el => { el.classList.remove('animation-fade-out', 'hidden'); });
          });
        }, 1000);
      },
      handleDataPopUp() {
        this.table_container = document.querySelector('.product-comparison__table-container');
        this.arrow_prev = document.querySelector('.product-comparison__nav-prev');
        this.arrow_next = document.querySelector('.product-comparison__nav-next');
        this.table_container.addEventListener('scroll', () => { this.scrollPosition = this.table_container.scrollLeft; this.updateArrowStatus(); });
        if (this.arrow_prev && this.arrow_next) {
          setTimeout(() => { this.updateArrowStatus(); }, 500);
          this.arrow_prev.addEventListener('click', () => this.slide(false));
          this.arrow_next.addEventListener('click', () => this.slide(true));
          this.arrow_prev.addEventListener('keyup', (e) => { if (e.key === 'Enter') { this.slide(false); } });
          this.arrow_next.addEventListener('keyup', (e) => { if (e.key === 'Enter') { this.slide(true); } });
        }
        const listProductData = [];
        const fetchPromises = this.listComparisonProducts.map(async (item, index) => {
          const url_product = `/products/${item.productHandle}?section_id=product-comparison-grid-item`;
          if (this.cacheResults[url_product]) { return Promise.resolve({index, data: this.cacheResults[url_product]}); }
          if (!this.loadingFetchDataPopup) { this.loadingFetchDataPopup = true; }
          return fetch(url_product).then(r => r.text()).then(r => { this.cacheResults[url_product] = r; return {index, data: r}; });
        });
        Promise.all(fetchPromises).then((results) => {
          results.sort((a, b) => a.index - b.index);
          results.forEach(r => listProductData.push(r.data));
          const table = document.querySelector('.product-comparison-table-popup');
          listProductData.forEach((item, index) => {
            const itemHtml = new DOMParser().parseFromString(item, 'text/html');
            [['table-header',`table-header-${this.listComparisonProducts[index].productHandle}-${index}`],['rating',`rating-${this.listComparisonProducts[index].productHandle}-${index}`],['sku',`sku-${this.listComparisonProducts[index].productHandle}-${index}`],['description',`description-${this.listComparisonProducts[index].productHandle}-${index}`],['vendor',`vendor-${this.listComparisonProducts[index].productHandle}-${index}`],['vendor-new-tab',`vendor-new-tab-${this.listComparisonProducts[index].productHandle}-${index}`]].forEach(([gI, tC]) => {
              const ic = itemHtml.querySelector(`.product-comparison-${gI}`);
              const tc = table.querySelector(`.product-comparison-${tC}`);
              if (ic && tc && ic.innerHTML.trim()) { tc.innerHTML = ic.innerHTML; }
            });
            this.array_variant_options.forEach((option) => {
              const k = option.replaceAll(" ", "_");
              const io = itemHtml.querySelector(`.product-comparison-option-${k}`);
              table.querySelectorAll(`.product-comparison-option-${k}-${index}`).forEach(t => { if (io && io.innerHTML.trim()) t.innerHTML = io.innerHTML; });
              const is = itemHtml.querySelector(`.product-comparison-option-swatches-${k}`);
              table.querySelectorAll(`.product-comparison-option-swatches-${k}-${index}`).forEach(t => { if (is && is.innerHTML.trim()) t.innerHTML = is.innerHTML; });
            });
            this.array_product_metafields.forEach((metafield) => {
              const k = metafield.replaceAll(".", "_");
              const im = itemHtml.querySelector(`.product-comparison-metafield-${k}`);
              table.querySelectorAll(`.product-comparison-metafield-${k}-${index}`).forEach(t => { if (im && im.innerHTML.trim()) t.innerHTML = im.innerHTML; });
            });
          });
          if (this.loadingFetchDataPopup) { this.loadingFetchDataPopup = false; }
        });
      }
    });
  });
});

/* ── Fonctions utilitaires (ancien theme.js uniquement) ── */
function getCSSVariable(element, variableName) {
  return parseFloat(getComputedStyle(element).getPropertyValue(variableName)) || 0;
}

function getValueCssVariable(varName, element = document.documentElement, shouldConvertToFloat = false) {
  const value = getComputedStyle(element).getPropertyValue(varName).trim();
  if (!shouldConvertToFloat) return value;
  if (!value) return 0;
  const rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
  const elementFontSize = parseFloat(getComputedStyle(element).fontSize);
  const numericValue = parseFloat(value);
  if (isNaN(numericValue)) return 0;
  if (value.endsWith('ms')) return numericValue;
  if (value.endsWith('s')) return numericValue * MS_PER_SECOND;
  if (value.endsWith('rem')) return numericValue * rootFontSize;
  if (value.endsWith('em')) return numericValue * elementFontSize;
  return numericValue;
}

function getOptionSelectedValues(productId, variantId) {
  let optionsSelectedValues = [];
  const listOptionsValues = window.Maximize.productOptionValues?.has(`${productId}`) ? window.Maximize.productOptionValues.get(`${productId}`) : new Map();
  const listVariantInfo = window.Maximize.variantInfo?.has(`${productId}`) ? window.Maximize.variantInfo.get(`${productId}`) : [];
  const variantOptionsInfo = listVariantInfo.find(variant => variant.id === variantId)?.options || [];
  for (let i = 0; i < variantOptionsInfo.length; i++) {
    let optionValueSelected = listOptionsValues.find(optionValue => optionValue.position === i + 1 && optionValue.value === variantOptionsInfo[i]);
    optionsSelectedValues.push(optionValueSelected ? optionValueSelected.id : null);
  }
  return optionsSelectedValues;
}